<div class="nav-bar-css">
  <div class="container">
    <div class="navbar-header">
      <a class="navbar-brand" style="cursor: default;"> <img src="assets/icon/gigsumologo_bigface.png"
          class="logo-size_define" width="auto" height="50px"></a>
    </div>
    <ul class="nav nav-right" style="float: right;">
      <li class="nav-item" ngbDropdown>
        <div dropdown container="body" (onShown)="onShown()" (onHidden)="onHidden()" (isOpenChange)="isOpenChange()">
          <!-- <img *ngIf="photoId==undefined || photoId==null || photoId==''" alt="logo" href id="basic-link" dropdownToggle
            (click)="false" aria-controls="basic-link-dropdown" class="img-circle m-t-md photoNav"
            src="assets/images/userAvatar.png"> -->

          <img *ngIf="photoId!==undefined && photoId!==null && photoId!==''" alt="logo" href id="basic-link"
            dropdownToggle (click)="false" aria-controls="basic-link-dropdown" class="img-circle m-t-md photoNav"
            [src]="img.src">
            
          <div *ngIf="photoId==undefined || photoId==null || photoId==''" class="header-img-pos" dropdownToggle>
            <div class="circles" [style.background-color]="getColortwo(firstName, lastName)">
              <div class="circle-text" [style.color]="getTextColor(firstName, lastName)">{{ getInitialstwo(firstName, lastName) }}
              </div>
            </div>
          </div>

          <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="basic-link">
            <li role="menuitem"><a id="userClassification_logout_link" class="dropdown-item" (click)="onLogout()">Sign Out</a></li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
<section class="sectionSI">
  <div class="stepUIWrapper">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="stepUIwrap" style="cursor: pointer;">
      <li [ngbNavItem]="1">
        <a ngbNavLink class="num-symb stepUIwrap" (click)="userClassificationForm.value.purpose != null ? nav.select(1) : prompt()"
          [ngStyle]="{'color':active==1 ?'#000000' : '#808080' }">1</a>
        <ng-template ngbNavContent>
          <h2 class="UIheadTxt">How will you use <span>GigSumo</span>?</h2>

          <div class="stepAction" style="flex-direction: row-reverse;">
            <button id="userClassification_step1_next_button" class="nextStep" *ngIf="userClassificationForm.value.purpose!=null"
              (click)="nav.select(2)">NEXT</button>
            <button id="userClassification_step1_next_prompt_button" class="nextStep" *ngIf="userClassificationForm.value.purpose==null" (click)="prompt()">NEXT</button>
          </div>

          <form [formGroup]="userClassificationForm">
            <div class="contentInside cIv2">
              <div class="userProfileCreateWrap">
                <div class="userImageUp">
                  <div class="profile-pic">

                    <img *ngIf="photoId != undefined && photoId != null" class="profile-image-view" [src]="img.src"
                      height="200">
                    <!-- <img alt="User Pic" *ngIf="photoId == undefined || photoId == null"
                      class="img-circle profile-image-view" src="assets/images/userAvatar.png" id="profile-image1"
                      height="200"> -->
                    <div *ngIf="photoId==undefined || photoId==null || photoId==''">
                      <div class="circles img-small1" [style.background-color]="getColortwo(firstName, lastName)">
                        <div class="circle-text font-size-65"  [style.color]="getTextColor(firstName, lastName)">{{ getInitialstwo(firstName, lastName) }}
                        </div>
                      </div>
                    </div>
                    <!-- <img alt="User Pic" src="https://d30y9cdsu7xlg0.cloudfront.net/png/138926-200.png"
                      id="profile-image1" height="200"> -->
                    <input id="userClassification_profileImage" class="hidden" type="file" accept="image/*"
                      (click)="myFileInput.value=null" #myFileInput
                      (change)="fileChangeEvent($event,templatePhoto)">



                    <ng-template #templatePhoto>
                      <div class="modal-content">
                        <div style="padding: 14px 14px !important;">
                          <label>Profile Photo</label>
                          <button id="userClassification_photo_close_button" type="button" class="close pull-right" aria-label="Close" (click)="closePhoto()">
                            <span style="font-size: 2.5rem;" aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <hr style="margin: 0px !important; padding: 0px !important">
                        <div class="modal-body">
                          <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                            [aspectRatio]="4 / 4" format="jpeg" (imageCropped)="imageCropped($event)"
                            (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
                        </div>
                        <div class="modal-footer" style="border-radius: 5px !important;">
                          <div style="float: right;">
                            <button id="userClassification_photo_cancel_button" class="btn default-btn" (click)="closePhoto()">Cancel</button>
                            <button id="userClassification_photo_apply_button" class="btn primary-btn" (click)="imageLoaded()">Apply</button>
                          </div>
                        </div>
                      </div>

                    </ng-template>

                    <div style="color:#999;"> </div>
                  </div>
                  <div class="left-push">
                    <button id="userClassification_add_photo_button" class="btn btn-primary" (click)="uploadPhotoHere()">Add Photo</button>
                  </div>
                </div>
                <div class="userContentDetails">
                  <!-- <div class="userFieldInline">
                    <div class="input-field">
                      <label>First Name</label>
                      <input type="text" name="" id="userClassification_firstName" disabled formControlName="firstName" placeholder="First Name">
                      <div *ngIf="
                        e.firstName.invalid &&
                        (e.firstName.dirty || e.firstName.touched)
                      ">
                        <div *ngIf="e.firstName.errors.required" style="color: red;">
                          First Name is required
                        </div>
                        <div *ngIf="e.firstName.errors.pattern" style="color: red;">First Name must contain alphabet
                          only</div>
                      </div>
                    </div>
                    <div class="input-field">
                      <label>Last Name</label>
                      <input type="text" name="" disabled id="userClassification_lastName" formControlName="lastName" placeholder="Last Name">
                      <div *ngIf="
                      e.lastName.invalid &&
                      (e.lastName.dirty || e.lastName.touched)
                    ">
                        <div *ngIf="e.lastName.errors.required" style="color: red;">
                          Last Name is required
                        </div>
                        <div *ngIf="e.lastName.errors.pattern" style="color: red;">Last Name must contain alphabet
                          only</div>
                      </div>
                    </div>
                  </div> -->
                  <!-- <div class="userFieldInline">
                    <div class="input-field mrgin-0px">
                      <label>Email ID</label>
                      <input type="email" name="" id="userClassification_email" disabled formControlName="email" placeholder="Email">
                    </div>
                  </div> -->

                  <div class="contentInside ">
                    <div class="radio-with-Icon">
                      <p class="radioOption-Item">
                        <input type="radio" id="toTechnoGigs" formControlName="purpose" value="toTechnoGigs" />

                        <label for="toTechnoGigs">
                          <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 518 558" style="enable-background:new 0 0 518 558;" xml:space="preserve">
                            <style type="text/css">
                              .st0 {
                                fill: #545454;
                              }

                              .st1 {
                                fill: #E2A700;
                              }

                              .st2 {
                                fill: #B50D00;
                              }

                              .st3 {
                                fill: #C6C6C6;
                              }
                            </style>
                            <g>
                              <path class="st0" d="M131,482.3h-0.7c-29.1-1.9-51.2-12.8-65.9-32.3c-24.3-32.4-19.8-78.7-17.2-95.4c-25-26.1-37.3-54.6-36.4-84.9
		c1.3-45.6,32.2-81,44.6-93.5c-10.9-51.4,9-75.1,28-86c0.9-0.5,24.2-14.2,45.1-18.6c6-1.3,12,2.6,13.3,8.7c1.3,6-2.6,12-8.7,13.3
		c-17.2,3.6-38.2,15.9-38.5,16c-19.2,11-24.5,33.7-16,67.6c1,4.1-0.3,8.4-3.5,11.1c-0.4,0.3-40.6,36.1-41.9,82.1
		c-0.7,25.4,10.7,49.7,33.9,72.4c2.8,2.7,4,6.7,3.1,10.4c-0.1,0.5-11.1,52.3,12.2,83.3c10.6,14.1,27.2,21.9,49.3,23.4
		c6.2,0.4,10.9,5.7,10.5,11.9C141.8,477.8,136.9,482.3,131,482.3L131,482.3z" />
                              <path class="st0" d="M200.8,549.2c-6.4,0-12.8-0.8-19.2-2.4c-20.4-5.1-37.6-17.8-48.4-35.8c-17.9-29.7-14-68.2,9.4-93.7l38.4-41.7
		c4.2-4.5,11.3-4.9,15.8-0.7c4.5,4.2,4.9,11.3,0.7,15.8l-38.4,41.7c-16.7,18.2-19.5,45.8-6.7,67c7.7,12.9,20,22,34.6,25.6
		c14.6,3.6,29.7,1.4,42.6-6.4c17.5-10.5,27.2-26.4,27.2-44.9l0-381.5c0-31.6-25.7-57.4-57.3-57.4s-57.4,25.8-57.4,57.4
		c0,31.6,25.8,57.4,57.4,57.4c6.2,0,11.2,5,11.2,11.2s-5,11.2-11.2,11.2c-44,0-79.8-35.8-79.8-79.8c0-44,35.8-79.8,79.8-79.8
		c44,0,79.7,35.8,79.7,79.8v381.5c0,26.3-13.8,49.6-38,64.1C228.8,545.4,214.9,549.2,200.8,549.2L200.8,549.2z" />
                            </g>
                            <path class="st0" d="M230.5,111.1c-8.5,0-17.1-2.7-24.2-8.4c-2.4-1.9-2.9-5.4-1-7.8s5.4-2.9,7.8-1c12.2,9.6,29.8,7.4,39.4-4.7
	c1.3-1.7,2.4-3.4,3.2-5.2c3.9-8.2,2.7-16.9-3.7-25.8c-1.8-2.5-1.2-6,1.3-7.8c2.5-1.8,6-1.2,7.8,1.3c8.7,12.2,10.4,25.4,4.7,37.2
	c-1.2,2.5-2.7,4.9-4.5,7.3C253.7,106,242.1,111.1,230.5,111.1L230.5,111.1z" />
                            <path class="st0" d="M155,231c-0.4,0-0.9-0.1-1.3-0.2c-22.2-5.5-35.8-27.9-30.4-50.2c5.4-22.2,27.9-35.8,50.2-30.4
	c3,0.7,4.8,3.8,4.1,6.8c-0.7,3-3.8,4.9-6.8,4.1c-16.2-4-32.6,5.9-36.6,22.2c-4,16.2,6,32.6,22.2,36.6c3,0.7,4.8,3.8,4.1,6.8
	C159.8,229.3,157.5,231,155,231L155,231z" />
                            <path class="st0" d="M117.5,341c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c31,0,76.3-57.8,91.2-80c0.2-0.2,0.3-0.4,0.4-0.6
	c15-16.9,43.4-18.1,60.9-2.6c2.3,2.1,2.5,5.6,0.5,7.9c-2.1,2.3-5.6,2.5-7.9,0.5c-12.7-11.3-34-10.5-44.9,1.4
	C213.2,263,159.8,341,117.5,341L117.5,341z" />
                            <path class="st0" d="M163.7,414.6c-0.6,0-1.2-0.1-1.8-0.3l-38.1-12.8c-2.9-1-4.5-4.1-3.5-7.1c1-2.9,4.1-4.5,7.1-3.5l38.1,12.8
	c2.9,1,4.5,4.1,3.5,7.1C168.2,413.1,166,414.6,163.7,414.6L163.7,414.6z" />
                            <path class="st0"
                              d="M162.5,314.3c-1.5,0-3-0.6-4.1-1.8c-24.3-26.3-59.1-42.9-59.5-43.1c-2.8-1.3-4-4.6-2.7-7.4
	c1.3-2.8,4.6-4,7.4-2.7c1.5,0.7,37.1,17.7,62.9,45.6c2.1,2.3,2,5.8-0.3,7.9C165.2,313.8,163.9,314.3,162.5,314.3L162.5,314.3z" />
                            <path class="st1" d="M460.1,446.7c-26,0-47.1-21.1-47.1-47.1s21.1-47.1,47.1-47.1c25.9,0,47.1,21.1,47.1,47.1
	C507.2,425.6,486.1,446.7,460.1,446.7z M460.1,375c-13.6,0-24.7,11.1-24.7,24.7c0,13.6,11.1,24.7,24.7,24.7
	c13.6,0,24.7-11.1,24.7-24.7C484.8,386.1,473.7,375,460.1,375z" />
                            <path class="st2" d="M401.7,550c-26,0-47.1-21.1-47.1-47.1s21.1-47.1,47.1-47.1c25.9,0,47.1,21.1,47.1,47.1
	C448.8,528.9,427.7,550,401.7,550L401.7,550z M401.7,478.2c-13.6,0-24.7,11.1-24.7,24.7c0,13.6,11.1,24.7,24.7,24.7
	c13.6,0,24.7-11.1,24.7-24.7C426.4,489.3,415.3,478.2,401.7,478.2L401.7,478.2z" />
                            <path class="st1" d="M460.1,207.4c-26,0-47.1-21.1-47.1-47.1s21.1-47.1,47.1-47.1c25.9,0,47.1,21.1,47.1,47.1
	C507.2,186.3,486.1,207.4,460.1,207.4z M460.1,135.7c-13.6,0-24.7,11.1-24.7,24.7c0,13.6,11.1,24.7,24.7,24.7
	c13.6,0,24.7-11.1,24.7-24.7C484.8,146.8,473.7,135.7,460.1,135.7z" />
                            <path class="st2" d="M401.7,104.2c-26,0-47.1-21.1-47.1-47.1c0-26,21.1-47.1,47.1-47.1c25.9,0,47.1,21.1,47.1,47.1
	C448.8,83.1,427.7,104.2,401.7,104.2L401.7,104.2z M401.7,32.4c-13.6,0-24.7,11.1-24.7,24.7c0,13.6,11.1,24.7,24.7,24.7
	c13.6,0,24.7-11.1,24.7-24.7C426.4,43.5,415.3,32.4,401.7,32.4z" />
                            <g>
                              <path class="st3" d="M423.8,405.3h-40c-1.5,0-2.9-0.6-4-1.6l-63.1-63.1h-46.1c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6H319
		c1.5,0,2.9,0.6,4,1.6L386,394h37.7c3.1,0,5.6,2.5,5.6,5.6S426.8,405.3,423.8,405.3L423.8,405.3z" />
                              <path class="st3" d="M376.8,482.9c-1.4,0-2.9-0.6-3.9-1.6l-56.2-55.6h-46.1c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6H319
		c1.5,0,2.9,0.6,3.9,1.6l57.8,57.2c2.2,2.2,2.2,5.7,0.1,7.9C379.7,482.3,378.3,482.9,376.8,482.9L376.8,482.9z" />
                              <path class="st3" d="M319,230.7h-48.4c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6h46.1l63.1-63.1c1.1-1.1,2.5-1.6,4-1.6h40.5
		c3.1,0,5.6,2.5,5.6,5.6c0,3.1-2.5,5.6-5.6,5.6h-38.2L323,229C321.9,230,320.5,230.7,319,230.7L319,230.7z" />
                              <path class="st3" d="M319,145.4h-48.4c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6h46.1l55.6-55.6c2.2-2.2,5.7-2.2,7.9,0
		s2.2,5.7,0,7.9L323,143.8C321.9,144.9,320.5,145.4,319,145.4L319,145.4z" />
                              <path class="st3" d="M350.5,285.6h-80.8c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6h80.8c3.1,0,5.6,2.5,5.6,5.6
		C356,283.1,353.5,285.6,350.5,285.6L350.5,285.6z" />
                            </g>
                            <path class="st2" d="M394.2,327.1c-26,0-47.1-21.1-47.1-47.1s21.1-47.1,47.1-47.1s47.1,21.1,47.1,47.1S420.2,327.1,394.2,327.1
	L394.2,327.1z M394.2,255.3c-13.6,0-24.7,11.1-24.7,24.7c0,13.6,11.1,24.7,24.7,24.7c13.6,0,24.7-11.1,24.7-24.7
	C418.9,266.4,407.8,255.3,394.2,255.3z" />
                            <path class="st0" d="M267.9,479.9h-0.2c-3.1-0.1-5.5-2.7-5.4-5.8c0.3-8-3.6-15.2-10.4-18.8c-9.9-5.3-22.2-1.6-27.6,8.3
	c-1.5,2.7-4.9,3.8-7.6,2.2c-2.7-1.5-3.8-4.9-2.2-7.6c8.3-15.3,27.4-21.1,42.7-12.8c10.5,5.7,16.8,16.9,16.3,29.1
	C273.4,477.6,270.9,479.9,267.9,479.9L267.9,479.9z" />
                          </svg>
                          I'm looking for <br>
                          technology jobs
                          <span>Get direct access to jobs from Client, System Integrators, Staffing Agencies... </span>
                        </label>
                      </p>


                      <p class="radioOption-Item">
                        <input type="radio" id="toFindCandidates" formControlName="purpose" value="toFindCandidates" />

                        <label for="toFindCandidates">
                          <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 385 397" style="enable-background:new 0 0 385 397;" xml:space="preserve">
                            <style type="text/css">
                              .st0 {
                                fill: #C9C9C9;
                              }

                              .st1 {
                                fill: #686868;
                              }

                              .st2 {
                                fill: #BA2204;
                              }
                            </style>
                            <path class="st0" d="M254.2,369.5H131.8c-4.8,0-8.8,3.9-8.8,8.8s3.9,8.8,8.8,8.8h122.5c4.8,0,8.8-3.9,8.8-8.8
	S259.1,369.5,254.2,369.5z" />
                            <path class="st1" d="M129.6,342.1l4.4,2.8c2.9,1.8,9.3,5.2,13,7.1h95.5c11.3,0,20.5-9.2,20.5-20.5v-29.1c0-18.9-12.9-34.9-31.3-39
	l-56.2-12.5v-59.8c0-8.6-7-15.6-15.6-15.6h-3.8c-8.6,0-15.6,7-15.6,15.6v112.1H123v-47.5l-4.6,2.9c-7.7,3.9-12.3,11.1-12.9,19.4
	l0,22C106.2,317.3,115.2,333.1,129.6,342.1L129.6,342.1z" />
                            <path class="st1" d="M364.5,133.2h-31.2c-6,0-11.4,3.9-13.3,9.5c17.6,9.8,40.2,9.8,57.9,0C375.9,137.1,370.5,133.2,364.5,133.2
	L364.5,133.2z" />
                            <path class="st0"
                              d="M66,142.7c-2-5.6-7.3-9.5-13.3-9.5H21.5c-6,0-11.4,3.9-13.3,9.5C25.8,152.5,48.4,152.5,66,142.7L66,142.7z" />
                            <path class="st2"
                              d="M219.2,80.8c0,14.5-11.8,26.2-26.2,26.2s-26.2-11.8-26.2-26.2s11.8-26.2,26.2-26.2S219.2,66.3,219.2,80.8" />
                            <path class="st0" d="M241.5,127.7c-2.4-12-13-20.7-25.1-20.7h-46.8c-12.1,0-22.7,8.7-25.1,20.7v0
	C173.7,145.3,212.3,145.3,241.5,127.7L241.5,127.7z" />
                            <path class="st0" d="M366.4,115.8c0,9.7-7.8,17.5-17.5,17.5c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5
	C358.6,98.2,366.4,106.1,366.4,115.8" />
                            <path class="st1"
                              d="M54.6,115.8c0,9.7-7.8,17.5-17.5,17.5s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S54.6,106.1,54.6,115.8" />
                            <path class="st0" d="M140,40.3l12.4-12.4L168,43.5l-12.4,12.4L140,40.3z" />
                            <path class="st0" d="M218,43.5l15.6-15.6l12.4,12.4l-15.6,15.6L218,43.5z" />
                            <path class="st1" d="M184.2,10.8h17.5V37h-17.5V10.8z" />
                          </svg>
                          I am looking for<br> Candidates
                          <span>Get direct access to candidates from Suppliers or job seekers directly </span>
                        </label>
                      </p>


                      <!-- <p class="radioOption-Item">
                        <input type="radio" id="others"  formControlName="purpose" value="others" />

                        <label for="others">
                          <svg version="1.1" id="Layer_1"
                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 570 565"
                            style="enable-background:new 0 0 570 565;" xml:space="preserve">
                            <style type="text/css">
                              .st0 {
                                fill: #4F4F4F;
                              }

                              .st1 {
                                fill: #B70D04;
                              }
                            </style>
                            <path class="st0" d="M60.9,336.9c15.1,0,29.6-6,40.2-16.7c10.7-10.7,16.7-25.1,16.7-40.2s-6-29.6-16.7-40.2
	c-10.7-10.7-25.1-16.7-40.2-16.7s-29.6,6-40.2,16.7C10,250.5,4,264.9,4,280s6,29.6,16.7,40.2C31.3,330.9,45.8,336.9,60.9,336.9z
	 M60.9,240.6c10.4,0,20.5,4.1,27.8,11.5c7.4,7.4,11.5,17.4,11.5,27.8s-4.1,20.5-11.5,27.8c-7.4,7.4-17.4,11.5-27.8,11.5
	s-20.5-4.1-27.8-11.5c-7.4-7.4-11.5-17.4-11.5-27.8s4.1-20.5,11.5-27.8C40.4,244.8,50.4,240.6,60.9,240.6z" />
                            <path class="st0" d="M507.1,223.1c-15.1,0-29.6,6-40.2,16.7c-10.7,10.7-16.7,25.1-16.7,40.2s6,29.6,16.7,40.2
	c10.7,10.7,25.1,16.7,40.2,16.7s29.6-6,40.2-16.7C558,309.5,564,295.1,564,280s-6-29.6-16.7-40.2
	C536.7,229.1,522.2,223.1,507.1,223.1z M507.1,319.4c-10.4,0-20.5-4.1-27.8-11.5c-7.4-7.4-11.5-17.4-11.5-27.8s4.1-20.5,11.5-27.8
	c7.4-7.4,17.4-11.5,27.8-11.5s20.5,4.1,27.8,11.5c7.4,7.4,11.5,17.4,11.5,27.8s-4.1,20.5-11.5,27.8
	C527.6,315.2,517.6,319.4,507.1,319.4z" />
                            <path class="st0" d="M340.9,56.9c0-15.1-6-29.6-16.7-40.2C313.6,6,299.1,0,284,0s-29.6,6-40.2,16.7c-10.7,10.7-16.7,25.1-16.7,40.2
	s6,29.6,16.7,40.2c10.7,10.7,25.1,16.7,40.2,16.7s29.6-6,40.2-16.7C334.9,86.4,340.9,72,340.9,56.9z M244.6,56.9
	c0-10.4,4.1-20.5,11.5-27.8c7.4-7.4,17.4-11.5,27.8-11.5s20.5,4.1,27.8,11.5c7.4,7.4,11.5,17.4,11.5,27.8s-4.1,20.5-11.5,27.8
	c-7.4,7.4-17.4,11.5-27.8,11.5s-20.5-4.1-27.8-11.5C248.8,77.3,244.6,67.3,244.6,56.9z" />
                            <path class="st0" d="M340.9,503.1c0-15.1-6-29.6-16.7-40.2c-10.7-10.7-25.1-16.7-40.2-16.7s-29.6,6-40.2,16.7
	c-10.7,10.7-16.7,25.1-16.7,40.2s6,29.6,16.7,40.2C254.5,554,268.9,560,284,560s29.6-6,40.2-16.7
	C334.9,532.7,340.9,518.2,340.9,503.1L340.9,503.1z M244.6,503.1c0-10.4,4.1-20.5,11.5-27.8c7.4-7.4,17.4-11.5,27.8-11.5
	s20.5,4.1,27.8,11.5c7.4,7.4,11.5,17.4,11.5,27.8c0,10.4-4.1,20.5-11.5,27.8c-7.4,7.4-17.4,11.5-27.8,11.5s-20.5-4.1-27.8-11.5
	C248.8,523.6,244.6,513.6,244.6,503.1z" />
                            <path class="st0" d="M284,363.1c22,0,43.2-8.8,58.8-24.3s24.3-36.7,24.3-58.8s-8.8-43.2-24.3-58.8S306,196.9,284,196.9
	s-43.2,8.8-58.8,24.3s-24.3,36.7-24.3,58.8s8.8,43.2,24.3,58.8S262,363.1,284,363.1z M284,223.1c15.1,0,29.6,6,40.2,16.7
	c10.7,10.7,16.7,25.1,16.7,40.2s-6,29.6-16.7,40.2c-10.7,10.7-25.1,16.7-40.2,16.7s-29.6-6-40.2-16.7
	c-10.7-10.7-16.7-25.1-16.7-40.2s6-29.6,16.7-40.2C254.4,229.1,268.9,223.1,284,223.1z" />
                            <path class="st1" d="M139.6,280c0,38.3,15.2,75,42.3,102.1c27.1,27.1,63.8,42.3,102.1,42.3s75-15.2,102.1-42.3
	c27.1-27.1,42.3-63.8,42.3-102.1s-15.2-75-42.3-102.1c-27.1-27.1-63.8-42.3-102.1-42.3s-75,15.2-102.1,42.3
	C154.8,205,139.6,241.7,139.6,280z M284,179.4c26.7,0,52.3,10.6,71.2,29.5s29.5,44.5,29.5,71.2s-10.6,52.3-29.5,71.2
	s-44.5,29.5-71.2,29.5s-52.3-10.6-71.2-29.5s-29.5-44.5-29.5-71.2s10.6-52.3,29.5-71.2S257.3,179.4,284,179.4z" />
                            <path class="st1" d="M284,319.4c10.4,0,20.5-4.1,27.8-11.5c7.4-7.4,11.5-17.4,11.5-27.8s-4.1-20.5-11.5-27.8
	c-7.4-7.4-17.4-11.5-27.8-11.5s-20.5,4.1-27.8,11.5c-7.4,7.4-11.5,17.4-11.5,27.8s4.1,20.5,11.5,27.8
	C263.5,315.2,273.6,319.4,284,319.4z" />
                          </svg>
                          Others
                          <span>Get accees to GigSumo's social platform, communites and interact directly with
                            users.</span>
                        </label>
                      </p> -->



                    </div>

                  </div>

                </div>
              </div>
            </div>
          </form>
          <!-- <div class="stepAction">
            <button class="nextStep" *ngIf="userClassificationForm.value.purpose!=null && userClassificationForm.valid"
              (click)="nav.select(2)">NEXT</button>
            <button class="nextStep" *ngIf="userClassificationForm.value.purpose==null || !userClassificationForm.valid"
              (click)="prompt()">NEXT</button>
          </div> -->
        </ng-template>

      </li>
      <li [ngbNavItem]="2">
        <a class="num-symb stepUIwrap" [class.active]="active==2" (click)="navigateToStep2(nav)"
          [ngStyle]="{'color':active==2 ?'#000000' : '#808080' }">2</a>
        <ng-template ngbNavContent>
          <!-- <div class="stepAction">
            <button class="nextStep" (click)="nav.select(1)">Previous</button>
          </div> -->
          <!-- <h2 class="UIheadTxt">How will you use <span>Gig</span>Sumo.</h2> -->
          <p class="UISubtxt">Lets personalize how you will appear to your connections on the platform! </p>
          <h3 style="text-align:center; margin:50px;">What best describes you? </h3>



          <div>
            <h3 style="text-align: center;">I am a,</h3>
          </div>


          <!-- <div class="stepAction">
            <button class="nextStep" *ngIf="userClassificationForm.value.purpose!=null && userClassificationForm.valid"
            (click)="nav.select(1)">Back</button>
            <button class="nextStep" *ngIf="userClassificationForm.value.purpose!=null && userClassificationForm.valid"
              (click)="nav.select(2)">NEXT</button>
            <button class="nextStep" *ngIf="userClassificationForm.value.purpose==null || !userClassificationForm.valid"
              (click)="prompt()">NEXT</button>
          </div> -->



          <div class="stepAction">
            <button id="userClassification_step2_back_button" class="nextStep" (click)="nav.select(1)">Back</button>
            <button id="userClassification_step2_next_button" class="nextStep"
              *ngIf="(userClassificationForm.value.userType=='RECRUITER' || userClassificationForm.value.userType=='BENCH_RECRUITER' || userClassificationForm.value.userType=='MANAGEMENT_TALENT_ACQUISITION') && userClassificationForm.value.userType!=null"
              (click)="nav.select(3)">Next</button>
            <button id="userClassification_step2_submit_button" class="nextStep"
              *ngIf="(userClassificationForm.value.userType=='FREELANCE_RECRUITER'  || userClassificationForm.value.userType=='JOB_SEEKER') && userClassificationForm.value.userType!=null"
              (click)="passValue(userClassificationForm.value)">Submit</button>
            <button id="userClassification_step2_next_prompt_button" class="nextStep" (click)="prompt2()"
              *ngIf="userClassificationForm.value.userType==null">Next</button>
          </div>



          <form [formGroup]="userClassificationForm">
            <div class="contentInside">
              <div class="radio-with-Icon">
                <p class="radioOption-Item" *ngIf="userClassificationForm.value.purpose=='toFindCandidates'">
                  <input type="radio" name="userType" formControlName="userType" value="RECRUITER" id="RECRUITER"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="RECRUITER">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 508.3 518.4" style="enable-background:new 0 0 508.3 518.4;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #B7B7B7;
                        }

                        .st1 {
                          fill: #B70000;
                        }
                      </style>
                      <path d="M253.9,207.2c43.8,0,79.4-35.6,79.4-79.4c0-13.3-3.3-25.8-9.1-36.9l30-22.7l-8.4-11.2l-29.2,22.1
    c-14.5-18.7-37.2-30.8-62.7-30.8c-43.8,0-79.4,35.6-79.4,79.4C174.5,171.6,210.1,207.2,253.9,207.2L253.9,207.2z M253.9,62.4
    c20.9,0,39.5,9.9,51.5,25.2l-62.6,47.3l-24-24l-9.9,9.9l32.6,32.6l71.3-53.9c4.1,8.6,6.5,18.1,6.5,28.3c0,36.1-29.3,65.4-65.4,65.4
    s-65.4-29.4-65.4-65.4C188.4,91.7,217.8,62.4,253.9,62.4L253.9,62.4z" />
                      <path class="st0" d="M104.4,255.9c32.7,0,59.3-26.6,59.3-59.3c0-32.7-26.6-59.3-59.3-59.3S45,163.8,45,196.5
    C45,229.2,71.6,255.9,104.4,255.9L104.4,255.9z M104.4,151.2c25,0,45.3,20.3,45.3,45.3s-20.3,45.3-45.3,45.3S59,221.5,59,196.5
    C59,171.5,79.4,151.2,104.4,151.2L104.4,151.2z" />
                      <path class="st0" d="M343,196.5c0,32.7,26.6,59.3,59.3,59.3s59.3-26.6,59.3-59.3c0-32.7-26.6-59.3-59.3-59.3
    C369.6,137.2,343,163.8,343,196.5L343,196.5z M402.3,151.2c25,0,45.3,20.3,45.3,45.3s-20.3,45.3-45.3,45.3S357,221.5,357,196.5
    C357,171.5,377.3,151.2,402.3,151.2z" />
                      <path class="st0" d="M499.9,357c0-52.7-42.9-95.6-95.6-95.6c-15.4,0-30.5,3.7-44.1,10.7c-23.7-31.4-61.3-51.8-103.6-51.8
    c-42.8,0-80.7,20.8-104.3,52.8c-14-7.7-29.8-11.8-46-11.8c-52.7,0-95.6,42.9-95.6,95.6v73h116.3v18.3h259.2V430h113.6L499.9,357
    L499.9,357z M230.8,263l-7.5,24.3l-21.8-38.8c5.6-3.1,11.6-5.6,17.7-7.7L230.8,263z M243.5,269.3h22.1l11.5,35.1l-20.8,41.7
    l-23.6-41.9L243.5,269.3z M286,286.6l-7.8-23.8l11.4-23.5c5.8,1.7,11.4,4,16.8,6.5L286,286.6z M275.6,236.1l-9.3,19.2h-23.7
    l-9.6-18.4c7.7-1.6,15.6-2.5,23.8-2.5C263.1,234.4,269.4,235,275.6,236.1L275.6,236.1z M24.8,416v-59c0-45,36.6-81.6,81.6-81.6
    c13.4,0,26.5,3.3,38.3,9.5c-11.1,19.1-17.5,41.3-17.5,65v66L24.8,416z M372.3,434.3h-43.9v-67.7h-14v67.7H193.6v-67.7h-14v67.7
    h-38.5V350c0-38.7,19.2-73,48.6-94l67.4,120l61.6-123.4c32.2,20.5,53.7,56.5,53.7,97.5L372.3,434.3L372.3,434.3z M485.9,416h-99.6
    v-66c0-24.1-6.6-46.7-18.1-66c11.2-5.6,23.6-8.5,36.2-8.5c45,0,81.6,36.6,81.6,81.6L485.9,416L485.9,416z" />
                      <path class="st0" d="M134.1,466.3h245.2v14H134.1V466.3z" />
                      <path class="st0" d="M134.1,492.5H192v14h-57.9L134.1,492.5z" />
                      <path class="st0" d="M209.1,492.5h170.2v14H209.1V492.5z" />
                      <g>
                        <path class="st1" d="M246.9,13.2h14v20.5h-14V13.2z" />
                        <path class="st1" d="M141.9,120.8h21.2v14h-21.2L141.9,120.8z" />
                        <path class="st1" d="M347.7,120.8h21.2v14h-21.2V120.8z" />
                      </g>
                    </svg>
                    Recruiter
                  </label>
                </p>

                <p class="radioOption-Item"
                  *ngIf="userClassificationForm.value.purpose=='toFindCandidates' || userClassificationForm.value.purpose=='toTechnoGigs'">
                  <input type="radio" name="userType" formControlName="userType" id="FREELANCE_RECRUITER"
                    value="FREELANCE_RECRUITER" class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="FREELANCE_RECRUITER">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 508.3 518.4" style="enable-background:new 0 0 508.3 518.4;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #B7B7B7;
                        }

                        .st1 {
                          fill: #B70000;
                        }
                      </style>
                      <path d="M253.9,207.2c43.8,0,79.4-35.6,79.4-79.4c0-13.3-3.3-25.8-9.1-36.9l30-22.7l-8.4-11.2l-29.2,22.1
    c-14.5-18.7-37.2-30.8-62.7-30.8c-43.8,0-79.4,35.6-79.4,79.4C174.5,171.6,210.1,207.2,253.9,207.2L253.9,207.2z M253.9,62.4
    c20.9,0,39.5,9.9,51.5,25.2l-62.6,47.3l-24-24l-9.9,9.9l32.6,32.6l71.3-53.9c4.1,8.6,6.5,18.1,6.5,28.3c0,36.1-29.3,65.4-65.4,65.4
    s-65.4-29.4-65.4-65.4C188.4,91.7,217.8,62.4,253.9,62.4L253.9,62.4z" />
                      <path class="st0" d="M104.4,255.9c32.7,0,59.3-26.6,59.3-59.3c0-32.7-26.6-59.3-59.3-59.3S45,163.8,45,196.5
    C45,229.2,71.6,255.9,104.4,255.9L104.4,255.9z M104.4,151.2c25,0,45.3,20.3,45.3,45.3s-20.3,45.3-45.3,45.3S59,221.5,59,196.5
    C59,171.5,79.4,151.2,104.4,151.2L104.4,151.2z" />
                      <path class="st0" d="M343,196.5c0,32.7,26.6,59.3,59.3,59.3s59.3-26.6,59.3-59.3c0-32.7-26.6-59.3-59.3-59.3
    C369.6,137.2,343,163.8,343,196.5L343,196.5z M402.3,151.2c25,0,45.3,20.3,45.3,45.3s-20.3,45.3-45.3,45.3S357,221.5,357,196.5
    C357,171.5,377.3,151.2,402.3,151.2z" />
                      <path class="st0" d="M499.9,357c0-52.7-42.9-95.6-95.6-95.6c-15.4,0-30.5,3.7-44.1,10.7c-23.7-31.4-61.3-51.8-103.6-51.8
    c-42.8,0-80.7,20.8-104.3,52.8c-14-7.7-29.8-11.8-46-11.8c-52.7,0-95.6,42.9-95.6,95.6v73h116.3v18.3h259.2V430h113.6L499.9,357
    L499.9,357z M230.8,263l-7.5,24.3l-21.8-38.8c5.6-3.1,11.6-5.6,17.7-7.7L230.8,263z M243.5,269.3h22.1l11.5,35.1l-20.8,41.7
    l-23.6-41.9L243.5,269.3z M286,286.6l-7.8-23.8l11.4-23.5c5.8,1.7,11.4,4,16.8,6.5L286,286.6z M275.6,236.1l-9.3,19.2h-23.7
    l-9.6-18.4c7.7-1.6,15.6-2.5,23.8-2.5C263.1,234.4,269.4,235,275.6,236.1L275.6,236.1z M24.8,416v-59c0-45,36.6-81.6,81.6-81.6
    c13.4,0,26.5,3.3,38.3,9.5c-11.1,19.1-17.5,41.3-17.5,65v66L24.8,416z M372.3,434.3h-43.9v-67.7h-14v67.7H193.6v-67.7h-14v67.7
    h-38.5V350c0-38.7,19.2-73,48.6-94l67.4,120l61.6-123.4c32.2,20.5,53.7,56.5,53.7,97.5L372.3,434.3L372.3,434.3z M485.9,416h-99.6
    v-66c0-24.1-6.6-46.7-18.1-66c11.2-5.6,23.6-8.5,36.2-8.5c45,0,81.6,36.6,81.6,81.6L485.9,416L485.9,416z" />
                      <path class="st0" d="M134.1,466.3h245.2v14H134.1V466.3z" />
                      <path class="st0" d="M134.1,492.5H192v14h-57.9L134.1,492.5z" />
                      <path class="st0" d="M209.1,492.5h170.2v14H209.1V492.5z" />
                      <g>
                        <path class="st1" d="M246.9,13.2h14v20.5h-14V13.2z" />
                        <path class="st1" d="M141.9,120.8h21.2v14h-21.2L141.9,120.8z" />
                        <path class="st1" d="M347.7,120.8h21.2v14h-21.2V120.8z" />
                      </g>
                    </svg>
                    Freelance Recruiter
                  </label>
                </p>

                <p class="radioOption-Item" *ngIf="userClassificationForm.value.purpose=='toTechnoGigs'">
                  <input type="radio" name="userType" formControlName="userType" id="BENCH_RECRUITER"
                    value="BENCH_RECRUITER" class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="BENCH_RECRUITER">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 570.2 553" style="enable-background:new 0 0 570.2 553;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #A3A3A3;
                        }

                        .st1 {
                          fill: #DDDDDD;
                        }

                        .st2 {
                          fill: #B70000;
                        }
                      </style>
                      <path class="st0" d="M409.9,474.6c0,8.5-3.4,17-9.3,23.8c-21.2,24.6-74.7,33.9-117.1,33.9c-42.4,0-96.7-8.5-117.1-33.9
                   c-5.9-6.8-9.3-15.3-9.3-23.8c0-53.5,33.9-101,84-119.6c3.4-0.8,7.6,0,10.2,3.4l37.3,52.6l34.8-50.1c2.5-3.4,6.8-4.2,10.2-3.4
                   C379.4,377.9,409.9,423.7,409.9,474.6L409.9,474.6z" />
                      <path class="st1" d="M140.1,474.6c0,11,3.4,21.2,9.3,29.7c-7.6,0.8-16.1,0.8-24.6,0.8C68.9,506,12,489.9,12,454.2
                   c0-47.5,29.7-89.9,74.7-106.1c3.4-1.7,7.6,0,10.2,3.4l32.2,45.8l29.7-43.3c2.5-3.4,6.8-4.2,10.2-3.4c8.5,3.4,16.1,8.5,23.8,13.6
                   C159.6,390.6,140.1,431.3,140.1,474.6L140.1,474.6z" />
                      <path class="st1" d="M555,454.2c0,11.9-6.8,28.8-38.2,40.7c-28.8,11-67.9,12.7-99.3,10.2c6.8-9.3,9.3-19.5,9.3-29.7
                   c0-44.1-19.5-84-52.6-111.1c9.3-6.8,18.7-11.9,29.7-16.1c3.4-1.7,7.6,0,9.3,3.4l32.2,45.8l29.7-43.3c2.5-3.4,6.8-4.2,10.2-3.4
                   C527.9,367.7,555,408.4,555,454.2L555,454.2z" />
                      <path class="st1" d="M174.9,298.9c0,25.5-21.2,46.7-46.7,46.7c-25.5,0-46.7-21.2-46.7-46.7c0-25.5,21.2-46.7,46.7-46.7
                   C154.5,252.3,174.9,273.5,174.9,298.9z" />
                      <path class="st1" d="M493.1,298.9c0,25.5-21.2,46.7-46.7,46.7c-25.5,0-46.7-21.2-46.7-46.7c0-25.5,21.2-46.7,46.7-46.7
                   C471.9,252.3,493.1,273.5,493.1,298.9L493.1,298.9z" />
                      <path class="st2" d="M287.8,336.3c-63.6,0-114.5-50.9-114.5-113.7c0-62.8,50.9-113.7,113.7-113.7c62.8,0,113.7,50.9,113.7,113.7
                   C401.5,285.4,350.6,336.3,287.8,336.3L287.8,336.3z M287.8,125.8c-53.5,0-96.7,43.3-96.7,96.7c0,53.5,42.4,96.7,96.7,96.7
                   c53.5,0,96.7-43.3,96.7-96.7C384.5,169.1,341.2,125.8,287.8,125.8z" />
                      <path class="st1" d="M224.1,231.1c-5.1,0-8.5-3.4-8.5-8.5c0-39.9,32.2-71.3,71.3-71.3c5.1,0,8.5,3.4,8.5,8.5s-3.4,8.5-8.5,8.5
                   c-30.5,0-54.3,24.6-54.3,54.3C232.6,227.7,229.2,231.1,224.1,231.1L224.1,231.1z" />
                      <path d="M486.3,86.8l-68.7,54.3l5.1,5.9c3.4,3.4,3.4,8.5-0.8,11.9c-3.4,3.4-8.5,3.4-11.9,0c-0.8-0.8-20.4-22.1-19.5-21.2l-2.5,2.5
                   c-3.4-4.2-7.6-8.5-11.9-12.7l2.5-2.5c-0.8-0.8-20.4-22.1-19.5-21.2c-3.4-3.4-3.4-8.5,0-11.9s8.5-3.4,11.9,0.8l5.1,5.9l60.2-65.3
                   c14.4-15.3,39-16.1,53.5,0C505,49.5,502.4,73.2,486.3,86.8L486.3,86.8z" />
                    </svg>
                    Bench Sales Recruiter
                  </label>
                </p>
                <p class="radioOption-Item" *ngIf="userClassificationForm.value.purpose=='toTechnoGigs'">
                  <input type="radio" name="userType" formControlName="userType" id="JOB_SEEKER" value="JOB_SEEKER"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="JOB_SEEKER">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 577.4 546" style="enable-background:new 0 0 577.4 546;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #E0E0E0;
                        }

                        .st1 {
                          fill: #B5B5B5;
                        }

                        .st2 {
                          fill: #B70000;
                        }
                      </style>
                      <path class="st0" d="M231.3,318.1h-89.8c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6h89.8c3.3,0,6,2.7,6,6
    C237.3,315.5,234.6,318.1,231.3,318.1z" />
                      <path class="st1"
                        d="M255.3,372h-12c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6h12c3.3,0,6,2.7,6,6C261.3,369.3,258.6,372,255.3,372z" />
                      <path class="st0"
                        d="M218.2,372h-76.7c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6h76.7c3.3,0,6,2.7,6,6C224.1,369.3,221.5,372,218.2,372z" />
                      <path class="st1"
                        d="M303.2,425.8h-11c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6h11c3.3,0,6,2.7,6,6C309.2,423.1,306.5,425.8,303.2,425.8z" />
                      <path class="st0" d="M265.8,425.8H141.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6h124.3c3.3,0,6,2.7,6,6
    C271.8,423.1,269.1,425.8,265.8,425.8L265.8,425.8z" />
                      <path class="st1" d="M387.4,479.8H99.2c-16.5,0-29.9-13.4-29.9-29.9V50.3c0-16.5,13.4-29.9,29.9-29.9h288.2
    c16.5,0,29.9,13.4,29.9,29.9V138c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6V50.3c0-9.9-8.1-17.9-17.9-17.9H99.2c-9.9,0-17.9,8.1-17.9,17.9
    v399.6c0,9.9,8.1,17.9,17.9,17.9h288.2c9.9,0,17.9-8.1,17.9-17.9c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6
    C417.3,466.4,403.9,479.8,387.4,479.8L387.4,479.8z" />
                      <path
                        d="M418.3,170c0,4.6-3.8,8.4-8.4,8.4c-4.6,0-8.4-3.8-8.4-8.4c0-4.6,3.8-8.4,8.4-8.4C414.5,161.6,418.3,165.3,418.3,170" />
                      <path class="st0" d="M327.4,539.7H39.2c-16.5,0-29.9-13.4-29.9-29.9V110.1c0-16.5,13.4-29.9,29.9-29.9h7.4c3.3,0,6,2.7,6,6
    c0,3.3-2.7,6-6,6h-7.4c-9.9,0-17.9,8.1-17.9,17.9v399.6c0,9.9,8.1,17.9,17.9,17.9h288.2c9.9,0,17.9-8.1,17.9-17.9v-7.2
    c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6l0,7.2C357.3,526.2,343.9,539.7,327.4,539.7L327.4,539.7z" />
                      <path class="st2" d="M333.1,111.9h-41.3v-15c0-12.5-10.2-22.7-22.7-22.7h-51.5c-12.5,0-22.7,10.2-22.7,22.7v15h-41.3
    c-9.9,0-17.9,8.1-17.9,17.9v116.5c0,9.9,8.1,17.9,17.9,17.9h109.8c3.3,0,6-2.7,6-6s-2.7-6-6-6H153.5c-3.3,0-6-2.7-6-6V174h68.3v12.4
    c0,9.9,8.1,17.9,17.9,17.9h19.2c9.9,0,17.9-8.1,17.9-17.9V174h68.3v11.5c0,3.3,2.7,6,6,6c3.3,0,6-2.7,6-6v-55.7
    C351.1,119.9,343,111.9,333.1,111.9L333.1,111.9z M206.8,96.9c0-5.9,4.8-10.8,10.8-10.8h51.5c5.9,0,10.8,4.8,10.8,10.8v15h-73.1
    L206.8,96.9z M258.9,186.4c0,3.3-2.7,6-6,6h-19.2c-3.3,0-6-2.7-6-6V162c0-3.3,2.7-6,6-6h19.2c3.3,0,6,2.7,6,6V186.4z M339.1,162
    h-68.3c0-9.9-8.1-17.9-17.9-17.9h-19.2c-9.9,0-17.9,8.1-17.9,17.9h-68.3v-32.2c0-3.3,2.7-6,6-6h179.7c3.3,0,6,2.7,6,6L339.1,162
    L339.1,162z" />
                      <path d="M558.7,426.4l-59.2-59c8.6-16.5,13.4-35.2,13.4-55c0-66-53.7-119.7-119.8-119.7c-66,0-119.8,53.7-119.8,119.7
    s53.7,119.7,119.8,119.7c19.9,0,38.7-4.9,55.3-13.5l59.1,58.9c14.1,14.1,37.1,14.1,51.1,0C572.8,464,572.8,439.8,558.7,426.4
    L558.7,426.4z M285.4,312.5c0-59.4,48.4-107.7,107.8-107.7c59.4,0,107.8,48.3,107.8,107.7c0,59.4-48.4,107.7-107.8,107.7
    C333.8,420.1,285.4,371.8,285.4,312.5z M550.4,468.9C550.3,468.9,550.3,468.9,550.4,468.9c-9.5,9.5-24.9,9.5-34.3,0.1l-56.9-56.7
    c13.6-9,25.2-20.6,34.1-34.2l57,56.8C559.7,443.8,559.7,460,550.4,468.9L550.4,468.9z" />
                      <path
                        d="M437.5,382.2c-3.3,0-6-2.7-6-6v-52.1c0-4.6-3.8-8.4-8.4-8.4h-59.9c-4.6,0-8.4,3.8-8.4,8.4v52.1c0,3.3-2.7,6-6,6s-6-2.7-6-6
    v-52.1c0-11.2,9.1-20.3,20.3-20.3h59.9c11.2,0,20.3,9.1,20.3,20.3v52.1C443.5,379.6,440.9,382.2,437.5,382.2L437.5,382.2z" />
                      <path d="M393.2,290.3c-16.5,0-29.9-13.4-29.9-29.9s13.4-29.9,29.9-29.9s29.9,13.4,29.9,29.9C423.2,276.9,409.8,290.3,393.2,290.3z
     M393.2,242.5c-9.9,0-18,8.1-18,17.9c0,9.9,8.1,17.9,18,17.9s18-8.1,18-17.9C411.2,250.5,403.2,242.5,393.2,242.5z" />
                    </svg>
                    Job Seeker
                  </label>
                </p>

                <!-- <p class="radioOption-Item" *ngIf="userClassificationForm.value.purpose=='toTechnoGigs'">
                  <input type="radio" name="userType" formControlName="userType" id="student" value="student"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="student">
                    <svg version="1.1" id="Layer_1"
                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 559.4 571.2"
                      style="enable-background:new 0 0 559.4 571.2;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #C6C6C6;
                        }

                        .st1 {
                          fill: #B70000;
                        }
                      </style>
                      <path class="st0" d="M144.3,412.9c-1.6,0-3.1-0.9-3.9-2.4c-1.1-2.2-0.2-4.8,1.9-5.9c31-15.8,32.6-22.8,32.6-24c0-2.4,2-4.4,4.4-4.4
    s4.4,2,4.4,4.4c0,5.9-4.2,14.9-37.4,31.8C145.7,412.7,145,412.9,144.3,412.9L144.3,412.9z" />
                      <path class="st0" d="M546.8,560H13.1c-2.4,0-4.4-2-4.4-4.4v-52.5c0-37.6,19.4-51.9,55.3-65.3c4.9-1.8,10.8-4.1,17.4-6.6
    c2.2-0.9,4.8,0.2,5.7,2.5c0.9,2.3-0.2,4.8-2.5,5.7c-6.7,2.6-12.6,4.9-17.6,6.7c-33.6,12.6-49.7,24.3-49.7,57.2l0,48.1h525v-48.1
    c0-32.8-16-44.6-49.7-57.2c-4.9-1.8-10.9-4.1-17.6-6.7c-2.2-0.9-3.4-3.4-2.5-5.7c0.9-2.3,3.4-3.4,5.7-2.5c6.6,2.6,12.6,4.8,17.5,6.7
    c35.9,13.4,55.3,27.8,55.3,65.3l0,52.5C551.2,558,549.2,560,546.8,560L546.8,560z" />
                      <path class="st0" d="M415.5,412.9c-0.7,0-1.4-0.2-2-0.5c-33.1-16.9-37.4-25.9-37.4-31.8c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4
    c0,1.2,1.6,8.1,32.6,24c2.1,1.1,3,3.7,1.9,5.9C418.7,412,417.1,412.9,415.5,412.9L415.5,412.9z" />
                      <path class="st0" d="M279.9,411.2c-59.3,0-157.5-92-157.5-196.9c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4c0,97,92.8,188.1,148.7,188.1
    c56,0,148.8-91.1,148.8-188.1c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4C437.4,319.2,339.2,411.2,279.9,411.2z" />
                      <path class="st0"
                        d="M179.3,385c-2.4,0-4.4-2-4.4-4.4v-35c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v35C183.7,383,181.7,385,179.3,385z" />
                      <path class="st0"
                        d="M380.5,385c-2.4,0-4.4-2-4.4-4.4v-35c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v35C384.9,383,383,385,380.5,385z" />
                      <path class="st0" d="M100.6,217.6c-0.7,0-1.5-0.2-2.1-0.6c-1.4-0.8-2.2-2.2-2.2-3.8c0-110,60.2-155.6,81.2-168.2l-17.8-10.7
    c-2.1-1.2-2.7-3.9-1.5-5.9C159.8,25.3,225.2,0,288.5,0c47.7,0,84.7,13.8,110,41.1c30.6,33,43.5,85.5,38.3,156.1
    c-0.1,1.9-1.5,3.5-3.3,3.9c-1.8,0.4-3.8-0.3-4.8-1.9l-41.8-67.8c-130.7-6.5-282.5,84.7-284,85.6
    C102.1,217.4,101.3,217.6,100.6,217.6L100.6,217.6z M171.7,31.5l16.7,10c1.4,0.8,2.2,2.4,2.1,4c-0.1,1.6-1.1,3.1-2.6,3.7
    c-0.2,0.1-21,9.3-41.5,34c-18.2,21.9-39.7,60.6-41.4,122.4c31.4-17.8,166.5-89.8,284.5-82.8c1.4,0.1,2.7,0.9,3.5,2.1l35.7,57.9
    c2.5-61.1-9.8-106.7-36.7-135.7C368.4,21.6,333.6,8.8,288.5,8.8C238.9,8.8,190.5,24.6,171.7,31.5L171.7,31.5z" />
                      <path class="st0" d="M279.9,472.5c-96.4,0-125.1-69.8-125.3-70.5c-0.8-2.3,0.4-4.8,2.7-5.6c2.3-0.8,4.8,0.4,5.6,2.7
    c0.2,0.6,26.5,64.6,117,64.6c89.1,0,116.9-64,117.1-64.7c0.9-2.2,3.4-3.4,5.7-2.5c2.2,0.9,3.4,3.3,2.5,5.6
    C404.9,402.8,374.6,472.5,279.9,472.5L279.9,472.5z" />
                      <g>
                        <path class="st1" d="M135.6,552.1c-2.4,0-4.4-2-4.4-4.4V398.1c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v149.6
      C139.9,550.1,138,552.1,135.6,552.1z" />
                        <path class="st1" d="M91.8,420c-1.7,0-3.4-1-4.1-2.8c-0.9-2.2,0.2-4.8,2.4-5.7l43.8-17.5c2.2-0.9,4.8,0.2,5.7,2.4
      c0.9,2.2-0.2,4.8-2.4,5.7l-43.8,17.5C92.9,419.9,92.3,420,91.8,420z" />
                        <path class="st1" d="M91.8,551.2c-2.4,0-4.4-2-4.4-4.4V415.6c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v131.2
      C96.2,549.3,94.2,551.2,91.8,551.2z" />
                      </g>
                      <g>
                        <path class="st1" d="M424.3,552.1c-2.4,0-4.4-2-4.4-4.4V398.1c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v149.6
      C428.7,550.1,426.7,552.1,424.3,552.1z" />
                        <path class="st1" d="M468,420c-0.5,0-1.1-0.1-1.6-0.3l-43.7-17.5c-2.2-0.9-3.3-3.4-2.4-5.7c0.9-2.2,3.4-3.3,5.7-2.4l43.7,17.5
      c2.2,0.9,3.3,3.4,2.4,5.7C471.4,419,469.8,420,468,420z" />
                      </g>
                      <path class="st1" d="M468,551.2c-2.4,0-4.4-2-4.4-4.4V415.6c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v131.2
    C472.4,549.3,470.5,551.2,468,551.2z" />
                      <path class="st0"
                        d="M161.8,376.2h-52.5c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4h52.5c2.4,0,4.4,2,4.4,4.4S164.2,376.2,161.8,376.2z" />
                      <path class="st0" d="M74.3,427.7c-2.4,0-4.4-2-4.4-4.4v-16.4c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v16.4
    C78.7,425.7,76.7,427.7,74.3,427.7z" />
                      <path class="st0" d="M74.3,411.2c-2.4,0-4.4-2-4.4-4.4c0-21.7,17.7-39.4,39.4-39.4c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4
    c-16.9,0-30.6,13.7-30.6,30.6C78.7,409.3,76.7,411.3,74.3,411.2L74.3,411.2z" />
                      <path class="st0"
                        d="M450.5,376.2H398c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4h52.5c2.4,0,4.4,2,4.4,4.4S453,376.2,450.5,376.2z" />
                      <path class="st0" d="M485.5,427.7c-2.4,0-4.4-2-4.4-4.4v-16.4c0-2.4,2-4.4,4.4-4.4s4.4,2,4.4,4.4v16.4
    C489.9,425.7,488,427.7,485.5,427.7z" />
                      <path class="st0" d="M485.5,411.2c-2.4,0-4.4-2-4.4-4.4c0-16.9-13.7-30.6-30.6-30.6c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4
    c21.7,0,39.4,17.7,39.4,39.4C489.9,409.3,488,411.2,485.5,411.2L485.5,411.2z" />
                    </svg>
                    Student
                  </label>
                </p> -->

              </div>
              <div class="radio-with-Icon">

                <p class="radioOption-Item"
                  *ngIf="userClassificationForm.value.purpose=='toFindCandidates' || userClassificationForm.value.purpose=='toTechnoGigs'">
                  <input type="radio" name="userType" formControlName="userType" id="MANAGEMENT_TALENT_ACQUISITION"
                    value="MANAGEMENT_TALENT_ACQUISITION" class="ng-valid ng-dirty ng-touched ng-empty"
                    aria-invalid="false">
                  <label for="MANAGEMENT_TALENT_ACQUISITION">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 512 521" style="enable-background:new 0 0 512 521;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #EAEAEA;
                        }

                        .st1 {
                          fill: #B70000;
                        }
                      </style>
                      <path class="st0" d="M422.4,89.8H89.6c-15.2,0-27.6,12.4-27.6,27.6v235.4c0,15.2,12.4,27.6,27.6,27.6h129v27.2h-47.7v22.7h170.3
    l0-22.7h-47.7v-27.2h129c15.2,0,27.6-12.4,27.6-27.6V117.4C450,102.2,437.6,89.8,422.4,89.8L422.4,89.8z M332.4,416.3v5.2H179.6
    v-5.2H332.4z M227.3,407.5v-27.2h57.3v27.2H227.3z M441.2,352.8c0,10.4-8.4,18.8-18.8,18.8H89.6c-10.4,0-18.8-8.4-18.8-18.8v-9.5
    h370.4L441.2,352.8z M441.2,334.5H70.8l0-217.1c0-10.4,8.4-18.8,18.8-18.8h332.8c10.4,0,18.8,8.4,18.8,18.8L441.2,334.5L441.2,334.5
    z" />
                      <path class="st1" d="M256,368.7c6.2,0,11.3-5.1,11.3-11.3c0-6.2-5.1-11.3-11.3-11.3s-11.3,5.1-11.3,11.3
    C244.7,363.6,249.8,368.7,256,368.7z M256,354.8c1.4,0,2.6,1.2,2.6,2.6c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6
    C253.4,356,254.6,354.8,256,354.8z" />
                      <path class="st1" d="M270.9,137.1l7-15.7h-47.1l7,15.6c-31.2,6.5-56,31-62.7,62.2l-14.1-6.3v47.1l14.1-6.3
    c6.8,31.2,31.5,55.7,62.7,62.2l-7,15.6h47.1l-7-15.6c31.9-6.6,56.7-31.7,63-63.6l17.2,7.7V193l-17.2,7.7
    C327.6,168.8,302.7,143.7,270.9,137.1L270.9,137.1z M264.4,130.2l-2.4,5.5l-7.6,17l-7.4-16.6h0l-2.6-5.9L264.4,130.2z M259.5,227.2
    c15.5,4.4,27.9,11.5,27.9,14.4v13.5h-66.2v-13.5c0-2.9,12.5-10,27.9-14.4l3.2-0.9v-12l-2.8-1.1c-6.3-2.5-10.5-9.3-10.5-17.1
    c0-10,6.8-18,15.3-18c8.4,0,15.3,8.1,15.3,18c0,7.8-4.2,14.7-10.5,17.1l-2.8,1.1v12L259.5,227.2z M169.7,226.6v-20.1l22.5,10.1
    L169.7,226.6z M183.2,230.1l30.3-13.6l-30.3-13.6c5.6-29.5,29.1-52.7,58.2-57.7l10.8,24.2c-12.3,1.2-21.9,12.6-21.9,26.6
    c0,10.1,5.1,19.2,13,23.8c-11.4,3.6-30.8,11.2-30.8,21.8v22.3h39.6l-10.7,24C212.1,282.5,188.8,259.4,183.2,230.1L183.2,230.1z
     M244.3,302.9l2.6-5.8h0l7.4-16.6l7.6,17h0l2.4,5.5L244.3,302.9z M267.2,287.8l-10.7-24h39.7v-22.3c0-10.6-19.4-18.2-30.8-21.8
    c7.9-4.6,13-13.7,13-23.8c0-14-9.7-25.4-22-26.6l10.8-24.2c30,5.4,53.4,29,58.5,59.1l-27.3,12.2l27.3,12.2
    C320.6,258.7,297.2,282.4,267.2,287.8L267.2,287.8z M342.3,226.6l-7.1-3.2l-15.4-6.9l22.5-10.1V226.6z" />
                      <path class="st0"
                        d="M140.7,483.1c-7.2,0-13.1,5.9-13.1,13.1s5.9,13.1,13.1,13.1c7.2,0,13.1-5.9,13.1-13.1S147.9,483.1,140.7,483.1z
     M140.7,506.4c-5.6,0-10.2-4.6-10.2-10.2s4.6-10.2,10.2-10.2s10.2,4.6,10.2,10.2C150.8,501.8,146.3,506.4,140.7,506.4z" />
                      <path class="st1" d="M25.7,142.2L19.9,154l-12.9,1.9l9.4,9.1l-2.2,12.9l11.6-6.1l11.6,6.1L35,164.9l9.4-9.1l-12.9-1.9L25.7,142.2z
     M31.9,163.9l1.5,8.6l-7.7-4l-7.7,4l1.5-8.6l-6.2-6.1l8.6-1.2l3.8-7.8l3.9,7.8l8.6,1.2L31.9,163.9z" />
                      <path class="st1" d="M145,27.9l-4-8.1l-4,8.1l-8.9,1.3l6.5,6.3l-1.5,8.9l8-4.2l8,4.2l-1.5-8.9l6.5-6.3L145,27.9z M145.1,39l-4.1-2.2
    l-4.1,2.2l0.8-4.6l-3.3-3.2l4.6-0.7l2.1-4.2l2.1,4.2l4.6,0.7l-3.3,3.2L145.1,39z" />
                      <path class="st1" d="M484,388l8,4.2l-1.5-8.9l6.5-6.3l-8.9-1.3l-4-8.1l-4,8.1l-8.9,1.3l6.5,6.3l-1.5,8.9L484,388z M477.4,379.1
    l4.6-0.7l2.1-4.2l2.1,4.2l4.6,0.7l-3.3,3.2l0.8,4.6l-4.1-2.2l-4.1,2.2l0.8-4.6L477.4,379.1z" />
                      <path class="st1" d="M484,62.5l-5.3,16.2h-17l13.8,10l-5.3,16.2l13.8-10l13.8,10l-5.3-16.2l13.8-10h-17L484,62.5z M489.1,87.6
    l3.1,9.7l-8.2-6l-8.2,6l3.1-9.7l-8.2-6h10.2l3.1-9.7l3.1,9.7h10.2L489.1,87.6z" />
                      <path class="st0" d="M437.6,10.7c-7.2,0-13.1,5.9-13.1,13.1c0,7.2,5.9,13.1,13.1,13.1c7.2,0,13.1-5.9,13.1-13.1
    C450.7,16.6,444.8,10.7,437.6,10.7z M437.6,34c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2c5.6,0,10.2,4.6,10.2,10.2
    C447.8,29.4,443.2,34,437.6,34z" />
                      <path class="st0" d="M493,255.3c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4S498.7,255.3,493,255.3z
     M493,273.3c-4.1,0-7.5-3.4-7.5-7.5c0-4.1,3.4-7.5,7.5-7.5c4.1,0,7.5,3.4,7.5,7.5S497.1,273.3,493,273.3z" />
                      <path class="st0"
                        d="M49.5,80.1c0,7.6,6.2,13.8,13.8,13.8S77,87.7,77,80.1s-6.2-13.8-13.8-13.8C55.7,66.3,49.5,72.5,49.5,80.1z
     M63.3,69.2c6,0,10.9,4.9,10.9,10.9c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9C52.4,74.1,57.3,69.2,63.3,69.2z" />
                      <path class="st0"
                        d="M104.2,496.3c1.9,0.5,3.8,0.9,5.8,1.3l0.6-2.9c-1.9-0.4-3.8-0.8-5.6-1.3L104.2,496.3z" />
                      <path class="st0"
                        d="M62.5,476.5c3.1,2.3,6.3,4.5,9.6,6.5l1.5-2.5c-3.2-1.9-6.4-4.1-9.4-6.3L62.5,476.5z" />
                      <path class="st0"
                        d="M82.4,488.5c3.5,1.7,7.1,3.2,10.7,4.5l1-2.7c-3.5-1.3-7.1-2.7-10.5-4.3L82.4,488.5z" />
                      <path class="st0"
                        d="M31.6,442.3c2,3.3,4.1,6.5,6.4,9.7l2.3-1.7c-2.2-3-4.4-6.2-6.3-9.4L31.6,442.3z" />
                      <path class="st0"
                        d="M21.7,421.4c1.3,3.6,2.8,7.2,4.4,10.7l2.6-1.2c-1.6-3.4-3.1-6.9-4.3-10.5L21.7,421.4z" />
                      <path class="st0"
                        d="M16,398.9c0.6,3.8,1.3,7.7,2.3,11.4l2.8-0.7c-0.9-3.6-1.7-7.4-2.2-11.1L16,398.9z" />
                      <path class="st0"
                        d="M45.4,460.9c2.6,2.9,5.3,5.6,8.2,8.2l2-2.2c-2.8-2.5-5.5-5.2-8-8L45.4,460.9z" />
                      <path class="st0" d="M17.7,381.6c0-1.9,0-3.8,0.1-5.7l-2.9-0.1c-0.1,2-0.1,3.9-0.1,5.9c0,1.9,0,3.8,0.1,5.7l2.9-0.1
    C17.7,385.4,17.7,383.5,17.7,381.6L17.7,381.6z" />
                      <path class="st0"
                        d="M19.9,358.9l-2.9-0.6c-0.4,1.9-0.7,3.9-1,5.8l2.9,0.4C19.2,362.7,19.6,360.8,19.9,358.9L19.9,358.9z" />
                      <path class="st0"
                        d="M496.2,429.1l2.9,0.3c0.2-2,0.3-3.9,0.3-5.9l-2.9,0C496.5,425.3,496.4,427.2,496.2,429.1L496.2,429.1z" />
                      <path class="st0"
                        d="M476.6,474.3l2.2,1.9c2.9-3.2,5.5-6.7,7.8-10.3l-2.5-1.6C481.9,467.8,479.4,471.1,476.6,474.3z" />
                      <path class="st0"
                        d="M490,453.2l2.7,1.2c1.7-4,3.1-8.1,4.2-12.3l-2.8-0.7C493.1,445.4,491.7,449.4,490,453.2L490,453.2z" />
                      <path class="st0"
                        d="M434,499.1l0.6,2.8c4.2-0.9,8.4-2.1,12.4-3.7l-1.1-2.7C442.2,497,438.1,498.2,434,499.1L434,499.1z" />
                      <path class="st0"
                        d="M457.3,490.1l1.5,2.5c3.7-2.2,7.3-4.7,10.6-7.4l-1.8-2.3C464.4,485.6,460.9,488,457.3,490.1L457.3,490.1z" />
                      <path class="st0" d="M415.9,500.8l-0.1,2.9c0.5,0,1.1,0,1.6,0c1.4,0,2.9,0,4.3-0.1l-0.1-2.9C419.7,500.8,417.8,500.9,415.9,500.8
    L415.9,500.8z" />
                      <path class="st0" d="M491.5,192.2h2.9v11.7h-2.9V192.2z" />
                      <path class="st0" d="M491.5,215.5h2.9v11.7h-2.9V215.5z" />
                      <path class="st0" d="M491.5,168.9h2.9v11.7h-2.9V168.9z" />
                      <path class="st0" d="M491.5,145.5h2.9v11.7h-2.9V145.5z" />
                    </svg>

                    Management - Talent Acquisition
                  </label>
                </p>
                <!-- <p class="radioOption-Item"
                  *ngIf="userClassificationForm.value.purpose=='others'">
                  <input type="radio" name="userType" formControlName="userType" id="managementOthe" value="other"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="managementOthe">
                    <svg version="1.1" id="Layer_1"
                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 453 555"
                      style="enable-background:new 0 0 453 555;" xml:space="preserve">
                      <style type="text/css">
                        .st0 {
                          fill: #DDDDDD;
                        }

                        .st1 {
                          fill: #C84427;
                        }
                      </style>
                      <path class="st0" d="M440.9,100.8c-7.3-14.6-20.2-24.6-38.6-29.1c-31.4-7.8-51,7.3-58.8,15.1C323.9,42,279.1,10.6,227,10.6
    S130.1,42,110,86.8c-7.8-7.8-27.4-23-58.8-15.1c-17.9,4.5-30.8,14.6-38.6,29.1c-11.2,22.4-9,54.3,7.3,94.6
    c17.9,44.8,11.2,61.6,7.8,63.8c-2.8,1.1-3.9,4.5-2.8,6.7c0.6,2.2,2.8,3.9,5,3.9h1.7c0.6,0,58.8-17.4,34.2-112c-5-19-3.4-33,3.9-42.6
    c10.1-11.8,28-12.9,34.2-12.9c-3.4,11.2-5,23-5,35.3c0,24.6,5,35.3,10.1,44.8c-6.2,2.8-9.5,7.8-10.1,14
    c-1.7,17.4,12.3,48.7,25.8,60.5c4.5,3.9,8.4,5,11.2,5.6c11.2,21.3,28,40.9,45.4,54.9c-1.7,6.7-7.3,24.6-24.6,31.9
    C75.8,379.7,21.5,457,20.9,543.8c0,1.7,0.6,2.8,1.7,3.9c1.1,1.1,2.2,1.7,3.9,1.7l200.5,0h200.5c1.7,0,2.8-0.6,3.9-1.7
    s1.7-2.2,1.7-3.9c0-86.2-54.9-164.1-135.5-193.2c-17.9-7.8-23.5-25.2-25.2-32.5c17.4-14,33.6-33.6,45.4-54.9
    c3.4-0.6,7.3-1.7,11.2-5.6c14-11.8,27.4-43.1,25.8-60.5c-0.6-6.2-4.5-11.2-10.1-14c5-10.1,10.1-20.2,10.1-44.8
    c0-12.3-1.7-24.1-5-35.3c6.2,0,24.1,0.6,34.2,12.3c7.8,9,9,23.5,3.9,42.6c-24.6,94.6,33.6,112,34.2,112h1.7c2.2,0,4.5-1.1,5.6-3.4
    c1.1-2.8,0-5.6-2.8-6.7c-3.9-2.8-10.6-19,7.3-63.8C449.9,155.1,452.1,123.2,440.9,100.8L440.9,100.8z M61.8,108.6
    c-10.1,12.3-12.3,29.7-6.2,52.6c14,53.2,0.6,77.8-11.8,89.6c1.1-11.8-1.1-30.2-12.3-58.8c-14.6-37-17.4-66.6-7.8-85.7
    C29.9,94.6,40,86.8,55.1,82.9c5-1.1,10.1-1.7,14.6-1.7c14.6,0,24.6,6.2,30.8,11.2C89.2,92.4,72.4,95.8,61.8,108.6L61.8,108.6z
     M421.9,538.2H32.1c2.2-68.3,40.3-129.9,98.6-163c22.4,24.1,90.7,122.6,91.8,123.8l1.7,1.7h0.6h0.6c0.6,0.6,1.7,0.6,2.2,0.6
    c0.6,0,1.7,0,2.2-0.6h0.6h0.6l1.7-1.7c0.6-1.1,68.9-99.7,91.8-123.8C381.6,408.2,419.6,469.8,421.9,538.2L421.9,538.2z M293.1,360.6
    c6.7,2.2,13.4,5.6,20.2,8.4c-21.8,24.6-71.1,94.6-86.2,116.5c-15.1-21.8-64.4-91.8-86.2-115.9c6.7-3.4,13.4-6.2,20.2-9
    c19-8.4,26.9-25.2,30.2-35.3c12.3,8.4,25.2,13.4,35.8,13.4s23-5,35.8-13.4C265.6,335.4,273.5,352.2,293.1,360.6L293.1,360.6z
     M321.6,249.2c-2.2,2.2-4.5,2.8-6.2,2.8c-2.8-0.6-5,0.6-6.2,2.8C288.6,296.2,248.8,327,227,327s-61.6-30.8-82.3-72.2
    c-1.1-2.2-3.9-3.4-6.2-2.8c-1.7,0.6-3.9-0.6-6.2-2.8c-11.8-10.1-23-38.6-21.8-51c0.6-4.5,5-5.6,7.8-6.2h0.6c0.6,0,0.6,0,1.1-0.6
    c0.6,0,0.6-0.6,0.6-0.6c0.6,0,0.6-0.6,1.1-0.6l0.6-0.6c0-0.6,0.6-0.6,0.6-1.1c0-0.6,0-0.6,0.6-1.1V187c1.7-23,8.4-24.6,19.6-26.9
    c11.2-2.8,25.8-6.2,36.4-30.2c17.4,43.7,55.4,38.6,86.8,34.2c34.7-5,56-6.2,65.5,24.1c0,0.6,0.6,1.1,1.1,1.7l1.7,1.7
    c0,0,0.6,0,0.6,0.6c0.6,0,1.1,0.6,1.1,0.6h0.6c2.8,0.6,7.3,1.7,7.8,6.2C344.6,211.1,333.4,239.1,321.6,249.2L321.6,249.2z
     M336.8,173.6c-15.1-28-45.4-24.1-72.8-20.2c-36.4,5-67.8,9.5-79.5-42.6c-0.6-2.8-2.8-4.5-5.6-4.5c-2.8,0-5,1.7-5.6,3.9
    c-9,33-21.3,36.4-33.6,39.2c-11.2,2.8-20.2,6.2-25.2,19.6c-2.8-6.7-4.5-15.7-4.5-30.8C110,73.9,162,21.8,226.4,21.8
    c64.4,0,116.5,52.1,116.5,116.5C343.5,156.8,340.7,165.8,336.8,173.6L336.8,173.6z M410.7,250.3c-12.3-11.2-25.8-36.4-11.8-89.6
    c6.2-23,3.9-40.3-6.2-52.6c-10.6-12.9-28-15.7-37.5-16.2c7.8-6.2,22.4-15.1,44.8-9.5c15.1,3.9,25.2,11.8,31.4,23.5
    c9.5,19,6.7,48.7-7.8,85.7C411.8,220.6,409.6,238.6,410.7,250.3L410.7,250.3z" />
                      <polygon class="st1" points="163,372 224,466 298,372 " />
                    </svg>
                    Management - Others
                  </label>
                </p> -->
                <!-- <p class="radioOption-Item">
                  <input type="radio" name="userType" formControlName="userType" id="Others" value="false"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false" style="">
                  <label for="Others">
                    <svg version="1.1" id="Layer_1"
                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 461 366"
                      style="enable-background:new 0 0 461 366;" xml:space="preserve">

                      <path class="st0" d="M276.7,53.8c-12.4,12.4-29.9,14.9-39.2,5.7c-9.3-9.3-6.7-26.8,5.7-39.2c12.4-12.4,29.9-14.9,39.2-5.7
    C291.7,23.9,289.1,41.4,276.7,53.8" />
                      <path class="st1" d="M125.2,176.5c-8.9-3.9-17.9-7.3-27.1-9.7c-9.7-2.3-20-3.6-31.1-3.9h-59v28h61.7c24.6,0,49.1,12.8,75.1,26.4
    c15.3,8,30.9,16.1,47.1,21.8C176,214.1,154.4,190.6,125.2,176.5L125.2,176.5z" />
                      <path class="st1" d="M397.7,163c-16,0.3-30.5,2.9-43.7,7.4c-0.9,0.3-1.8,0.7-2.7,1c-35.5,13-61,39.3-79,67.7
    c16-5.7,31.5-13.8,46.8-21.7c25.9-13.6,50.5-26.4,75.1-26.4H456v-28L397.7,163z" />
                      <path class="st0" d="M276.8,166.2c-12.4,12.4-29.9,14.9-39.2,5.7c-9.3-9.2-6.7-26.8,5.7-39.2c12.4-12.4,29.9-14.9,39.2-5.7
    C291.7,136.3,289.2,153.8,276.8,166.2" />
                      <path class="st0" d="M220.9,75.4c12.4,12.4,14.9,29.9,5.7,39.2c-9.3,9.3-26.8,6.7-39.2-5.7C175,96.5,172.5,79,181.7,69.7
    S208.5,63,220.9,75.4" />
                      <path class="st1" d="M232,359c-30.8,0-60.8-14.8-89.8-29.2c-27.5-13.6-53.5-26.5-78.2-26.5H7.9v-28H64c31.3,0,61.4,14.9,90.6,29.4
    c27.3,13.5,53.1,26.3,77.4,26.3c24.1,0,49.6-12.7,76.6-26.1c29.2-14.5,59.4-29.6,91.1-29.6h0.3h56v28h-56h-0.2
    c-25.2,0-51.2,12.9-78.7,26.6C292.4,344.2,262.7,359,232,359L232,359z" />
                      <path class="st1" d="M232,303.3c-30.8,0-60.8-14.8-89.8-29.2c-27.5-13.6-53.5-26.5-78.2-26.5H7.9v-28H64c31.3,0,61.4,14.9,90.6,29.4
    c27.3,13.5,53.1,26.3,77.4,26.3c24.1,0,49.6-12.7,76.6-26.1c29.2-14.5,59.4-29.6,91.1-29.6h0.3h56v28l-56,0h-0.2
    c-25.2,0-51.2,12.9-78.7,26.6C292.4,288.6,262.7,303.3,232,303.3L232,303.3z" />
                    </svg>
                    Others
                  </label>
                </p> -->
              </div>
            </div>
          </form>
          <!-- <div class="stepAction">
             <button class="nextStep"
              *ngIf="(userClassificationForm.value.userType=='RECRUITER' || userClassificationForm.value.userType=='FREELANCE_RECRUITER' || userClassificationForm.value.userType=='BENCH_RECRUITER' || userClassificationForm.value.userType=='MANAGEMENT_TALENT_ACQUISITION') && userClassificationForm.value.userType!=null"
              (click)="nav.select(3)">Next</button>
            <button class="nextStep"
              *ngIf="(userClassificationForm.value.userType=='student' || userClassificationForm.value.userType=='JOB_SEEKER') && userClassificationForm.value.userType!=null"
              (click)="passValue(userClassificationForm.value)">Submit</button>
            <button class="nextStep" (click)="prompt2()"
              *ngIf="userClassificationForm.value.userType==null">Next</button>
          </div> -->
        </ng-template>

      </li>
      <li [ngbNavItem]="3">
        <a class="num-symb stepUIwrap" [class.active]="active==3"
          [class.disabled]="userClassificationForm.value.userType == 'FREELANCE_RECRUITER' || userClassificationForm.value.userType == 'JOB_SEEKER'"
          (click)="navigateToStep3(nav)"
          [ngStyle]="{'color': (userClassificationForm.value.userType == 'FREELANCE_RECRUITER' || userClassificationForm.value.userType == 'JOB_SEEKER') ? '#cccccc' : (active==3 ? '#000000' : '#808080'),
                      'cursor': (userClassificationForm.value.userType == 'FREELANCE_RECRUITER' || userClassificationForm.value.userType == 'JOB_SEEKER') ? 'not-allowed' : 'pointer',
                      'pointer-events': (userClassificationForm.value.userType == 'FREELANCE_RECRUITER' || userClassificationForm.value.userType == 'JOB_SEEKER') ? 'none' : 'auto' }">3</a>
        <ng-template ngbNavContent>
          <form [formGroup]="userClassificationForm">
            <h2 class="UIheadTxt">What best describes your business or<br>
              the company you are working at present?</h2>
            <p class="UISubtxt">This will help us personalize <span>Gig</span>Sumo to best suit your needs. </p>


            <div class="stepAction" style="flex-direction: row-reverse;">


              <button id="userClassification_step3_submit_button" class="nextStep" *ngIf="userClassificationForm.value.clientType!=null"
                (click)="passValue(userClassificationForm.value)">Submit</button>
              <button id="userClassification_step3_submit_prompt_button" class="nextStep" *ngIf="userClassificationForm.value.clientType==null"
                (click)="prompt1()">Submit</button>
              <button id="userClassification_step3_back_button" class="nextStep" *ngIf="userClassificationForm.value.purpose!=null"
                (click)="nav.select(2)">Back</button>

            </div>

            <div class="contentInside">
              <div class="radio-with-Icon">
                <p class="radioOption-Item">
                  <input type="radio" name="clientType" formControlName="clientType" id="client" value="Client"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="client">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 557 560" style="enable-background:new 0 0 557 560;" xml:space="preserve">

                      <path class="st0" d="M265.4,10.1h28v28.6h-28V10.1z" />
                      <path class="st0" d="M265.4,519.7h28v28.6h-28V519.7z" />
                      <path class="st0" d="M78.4,438.5h28V467h-28V438.5z" />
                      <path class="st0" d="M444.6,438.5h28V467h-28V438.5z" />
                      <path class="st0" d="M78.4,88.5h28V117h-28V88.5z" />
                      <path class="st0" d="M444.6,88.5h28V117h-28V88.5z" />
                      <path class="st0" d="M7.3,262.6h28v28.6h-28V262.6z" />
                      <path class="st0" d="M523.6,262.6h28v28.6h-28V262.6z" />
                      <path class="st1" d="M58.8,136.1C37.5,168.6,24.1,204.4,19,242.5l-0.6,3.9h16.2l0.6-2.8c5.6-37,19.6-73.4,40.9-104.2l3.4-4.5H59.9
                 L58.8,136.1z" />
                      <path class="st1" d="M34.7,310.2V308H17.9l0.6,3.4c5,39.2,17.9,76.2,39.2,109.2l1.1,1.1h19.6l-3.4-4.5
                 C53.8,385.3,39.8,348.9,34.7,310.2L34.7,310.2z" />
                      <path class="st1" d="M523.6,243.6l0.6,2.8h16.2l-0.6-3.4c-5.6-38.1-18.5-73.9-39.8-106.4l-1.1-1.1h-19.6l3.4,4.5
                 C504,170.8,518,206.6,523.6,243.6L523.6,243.6z" />
                      <path class="st1" d="M524.2,308l-0.6,2.8c-5,38.1-18.5,75-40.3,107l-3.4,4.5h19.6l1.1-1.1c21.3-33,34.2-70,39.2-109.2l0.6-3.4
                 l-16.2,0L524.2,308z" />
                      <path class="st1" d="M414.4,72.8l0.6,0.6h28l-7.3-5.6c-35.8-26.3-77.8-43.7-122.1-49.3l-3.4-0.6v16.8l2.8,0.6
                 C349.4,39.8,383.6,52.6,414.4,72.8L414.4,72.8z" />
                      <path class="st1" d="M123.2,67.8l-7.3,5.6h28l0.6-0.6c30.8-20.2,65-33,101.9-38.1l2.8-0.6V17.4l-3.4,0.6
                 C201,24.1,159,41.4,123.2,67.8L123.2,67.8z" />
                      <path class="st1" d="M417.2,483.8c-30.8,20.7-67.2,34.7-104.2,39.8l-2.8,0.6V541l3.4-0.6c45.4-6.2,87.9-23.5,124.3-51.5l7.3-5.6
                 h-27.4L417.2,483.8z" />
                      <path class="st1" d="M141.7,483.8l-0.6-0.6h-27.4l7.3,5.6c36.4,27.4,79.5,45.4,124.9,51.5l3.4,0.6v-16.8l-2.8-0.6
                 C208.9,518.6,173,504.6,141.7,483.8L141.7,483.8z" />
                      <path class="st1" d="M269.4,132.2h20.2v33.6h-20.2V132.2z" />
                      <path class="st1" d="M391.4,250.3H425v20.2h-33.6V250.3z" />
                      <path class="st1" d="M137.2,250.3h33.6v20.2h-33.6V250.3z" />
                      <path class="st0" d="M208.4,186.1l-14.3,14.3l-23.8-23.8l14.3-14.3L208.4,186.1z" />
                      <path class="st0" d="M391.5,176.3l-23.8,23.8l-14.3-14.3l23.8-23.8L391.5,176.3z" />
                      <path class="st1" d="M279.4,182c-52.6,0-95.2,42.6-95.2,95.2c0,34.7,19,66.6,49.3,83.4v26.9c0,1.7,1.7,3.4,3.4,3.4h1.7v12.9
                 c0,1.7,1.7,3.4,3.4,3.4h5.6v10.1c0,1.7,1.7,3.4,3.4,3.4h58.2c1.7,0,3.4-1.7,3.4-3.4v-10.1h5c1.7,0,3.4-1.7,3.4-3.4v-12.9h2.2
                 c1.7,0,3.4-1.7,3.4-3.4v-26.9c30.2-16.8,49.3-48.7,49.3-83.4C374.6,224.6,332.1,182,279.4,182L279.4,182z M249.2,348.9l-3.4-1.7
                 c-26.9-12.9-44.2-40.3-44.2-70c0-43.1,34.7-77.8,77.8-77.8s77.8,34.7,77.8,77.8c0,29.7-17.4,57.1-44.2,70l-3.4,1.7
                 c-1.1,0.6-1.7,1.7-1.7,2.8v21.8h-57.1v-21.8C250.9,350.6,250.3,349.4,249.2,348.9L249.2,348.9z" />
                      <path class="st0" d="M309.7,272.7c0,15.8-12.8,28.6-28.6,28.6c-15.8,0-28.6-12.8-28.6-28.6s12.8-28.6,28.6-28.6
                 S309.7,256.9,309.7,272.7" />
                    </svg>
                    Client
                  </label>
                </p>

                <p class="radioOption-Item">
                  <input type="radio" name="clientType" formControlName="clientType" id="sysintegrator"
                    value="Systems Integrator" class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="sysintegrator">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 534.2 537.1" style="enable-background:new 0 0 534.2 537.1;" xml:space="preserve">

                      <path class="st0" d="M73.3,261.3c4.9-4.3,3.3-12.2-2.9-14.2c-2.8-0.9-5.8-0.3-8.1,1.6c-5.3,4.6-9.8,9.5-14.3,14.8
	c-4.3,5.2-8,10.3-11.6,15.9c-3.7,5.8,0.7,13.3,7.6,12.8c2.7-0.2,5-1.6,6.4-3.8C56.9,278.5,64.4,269,73.3,261.3L73.3,261.3z
	 M410.2,80.5c6.1,1.6,11.9,4,17.2,7.2L449,72l17.3,17.3l-15.6,21.6c3.1,5.3,5.6,11.1,7.1,17.2l26.3,4.2v24.4l-26.3,4.2
	c-1.6,6.1-4,11.9-7.2,17.2l15.6,21.6L449,217l-21.6-15.6c-5.3,3.1-11.1,5.6-17.2,7.1l-4.2,26.3h-24.4l-4.2-26.3
	c-6.1-1.6-11.9-4-17.2-7.2L338.6,217l-17.3-17.3l15.6-21.6c-3.1-5.3-5.6-11.1-7.1-17.2l-26.3-4.2v-24.4l26.3-4.2
	c1.6-6.1,4-11.9,7.1-17.2l-15.6-21.6L338.6,72l21.6,15.6c5.3-3.1,11.1-5.6,17.2-7.1l4.2-26.3H406L410.2,80.5z M393.8,108.4
	c-19.9,0-36.1,16.2-36.1,36.1s16.2,36.1,36.1,36.1s36.1-16.2,36.1-36.1C429.9,124.6,413.7,108.4,393.8,108.4z M168.2,268.5
	c55.6,0,100.7,45.1,100.7,100.7c0,24.6-8.8,47.1-23.5,64.6c-11.3-31.7-41.6-54.4-77.2-54.4c-35.6,0-65.9,22.7-77.2,54.4
	c-14.7-17.5-23.5-40-23.5-64.6C67.5,313.6,112.6,268.5,168.2,268.5L168.2,268.5z M168.2,291.4c-22.9,0-41.4,18.6-41.4,41.4
	s18.6,41.4,41.4,41.4c22.9,0,41.4-18.6,41.4-41.4S191.1,291.4,168.2,291.4z M168.2,251.8c64.8,0,117.4,52.6,117.4,117.4
	c0,64.8-52.6,117.4-117.4,117.4c-64.8,0-117.4-52.6-117.4-117.4C50.8,304.4,103.3,251.8,168.2,251.8z M100.2,215.9
	c-4.9,4.3-3.3,12.2,2.9,14.2c2.8,0.9,5.8,0.3,8.1-1.6l25.2-21.9c4.9-4.3,3.3-12.2-2.9-14.2c-2.8-0.9-5.8-0.3-8.1,1.6L100.2,215.9z
	 M163.3,161.2c-4.9,4.3-3.3,12.2,2.9,14.2c2.8,0.9,5.8,0.3,8.1-1.6l25.2-21.9c4.9-4.3,3.3-12.2-2.9-14.2c-2.8-0.9-5.8-0.3-8.1,1.6
	L163.3,161.2z M226.4,106.6c-4.9,4.3-3.3,12.2,2.9,14.2c2.8,0.9,5.8,0.3,8.1-1.6l25.2-21.9c4.9-4.3,3.3-12.2-2.9-14.2
	c-2.8-0.9-5.8-0.3-8.1,1.6L226.4,106.6z M289.5,51.9c-4.9,4.3-3.3,12.2,2.9,14.2c2.8,0.9,5.8,0.3,8.1-1.6c8.4-7.3,15-13.9,24.9-20
	c5.5-3.4,5.2-11.4-0.4-14.5c-2.7-1.4-5.8-1.3-8.3,0.3C306.4,36.7,298.5,44.1,289.5,51.9L289.5,51.9z M366.1,11.5
	c-6.6,1.1-9.3,9.2-4.6,14.1c1.9,2,4.6,2.9,7.4,2.4c10.4-1.8,20.7-2.2,31.2-1.4c6.4,0.5,11-6.1,8.2-11.9c-1.3-2.7-3.8-4.4-6.8-4.7
	C389.6,9,377.9,9.5,366.1,11.5L366.1,11.5z M452.5,24.4c-3.8-1.9-8.4-0.7-10.8,2.9c-2.7,4.2-1.2,9.7,3.2,12
	c9.3,4.7,18,10.6,25.8,17.5c4.8,4.3,12.5,1.7,13.7-4.6c0.6-2.9-0.4-5.9-2.6-7.9C473,36.4,463,29.7,452.5,24.4L452.5,24.4z
	 M514.1,86.2c-1.9-3.8-6.3-5.6-10.2-4.2c-4.7,1.7-6.9,7-4.7,11.6c4.7,9.5,8.1,19.1,10.3,29.4c0.7,3.5,3.6,6.1,7.2,6.6
	c5.7,0.7,10.3-4.3,9.2-10C523.4,108,519.4,96.8,514.1,86.2L514.1,86.2z M526.8,172.5c1.1-6.6-5.5-11.8-11.6-9.1
	c-2.6,1.1-4.3,3.4-4.8,6.2c-1.7,10.1-4.9,20.4-9.2,29.7c-1.8,3.8-0.4,8.3,3.1,10.6c4.3,2.7,9.9,1,12-3.6
	C521.1,195.9,524.8,184,526.8,172.5L526.8,172.5z M486.2,249c4.4-5.1,1.3-12.9-5.3-13.8c-2.8-0.3-5.5,0.7-7.3,2.8l-21.9,25.2
	c-4.4,5.1-1.3,12.9,5.3,13.8c2.8,0.3,5.5-0.7,7.3-2.8L486.2,249z M431.6,312.1c4.4-5.1,1.3-12.9-5.3-13.8c-2.8-0.3-5.5,0.7-7.3,2.8
	l-21.9,25.2c-4.4,5.1-1.3,12.9,5.3,13.8c2.8,0.3,5.5-0.7,7.3-2.8L431.6,312.1z M376.9,375.2c4.4-5.1,1.3-12.9-5.3-13.8
	c-2.8-0.3-5.5,0.7-7.3,2.8l-21.9,25.2c-4.4,5.1-1.3,12.9,5.3,13.8c2.8,0.3,5.5-0.7,7.3-2.8L376.9,375.2z M322.3,438.3
	c4.4-5.1,1.3-12.9-5.3-13.8c-2.8-0.3-5.5,0.7-7.3,2.8l-21.9,25.2c-4.4,5.1-1.3,12.9,5.3,13.8c2.8,0.3,5.5-0.7,7.3-2.8L322.3,438.3z
	 M262.6,499.4c5.3-3.6,4.8-11.5-0.9-14.4c-2.7-1.3-5.8-1.1-8.3,0.5c-8.7,5.9-18.1,10.9-27.9,14.7c-3.4,1.3-5.5,4.7-5.3,8.3
	c0.4,5.6,6.1,9.3,11.4,7.2c5.7-2.3,11.2-4.8,16.6-7.7C253.2,505.4,257.9,502.6,262.6,499.4L262.6,499.4z M180.2,526.8
	c6.3-0.3,10-7.3,6.7-12.7c-1.6-2.6-4.4-4.1-7.5-4c-10.4,0.5-21.1-0.1-31.4-1.9c-6.4-1.1-11.5,5.1-9.2,11.2c1.1,2.8,3.4,4.8,6.4,5.3
	c5.5,1,11.1,1.6,16.7,2C167.9,527,174,527.1,180.2,526.8L180.2,526.8z M95.4,507.4c5.5,3,12.2-0.9,12.4-7.2c0-3.1-1.6-6-4.3-7.5
	c-9.2-5-18-11.1-25.8-18c-4.8-4.2-12.3-1.7-13.7,4.5c-0.6,3,0.4,6,2.6,8c4,3.4,8,6.6,12.2,9.7C84.2,500.9,89.6,504.3,95.4,507.4
	L95.4,507.4z M33,446.8c3.2,5.5,11.1,5.6,14.4,0.1c1.5-2.6,1.6-5.8,0.1-8.4c-5.3-9.2-9.5-18.7-12.8-28.8c-1.9-5.8-9-7.7-13.5-3.7
	c-2.5,2.2-3.4,5.6-2.4,8.7c1.7,5.3,3.6,10.4,5.8,15.5C27.2,435.9,29.9,441.4,33,446.8L33,446.8z M11.4,362.6
	c-0.1,6.7,7.2,10.8,12.8,7.2c2.4-1.5,3.8-4,3.8-6.8c0.2-10.5,1.6-21,4-31.3c1.5-6.3-4.4-11.9-10.6-10c-2.8,0.9-4.9,3.1-5.6,6
	c-1.3,5.3-2.3,10.6-3,16C12,350.1,11.5,356.3,11.4,362.6L11.4,362.6z" />
                      <circle class="st1" cx="394.1" cy="144.5" r="35.4" />
                    </svg>
                    Systems Integrator
                  </label>
                </p>
                <p class="radioOption-Item">
                  <input type="radio" name="clientType" formControlName="clientType" id="Prime Vendor"
                    value="Prime Vendor" class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="Prime Vendor">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 406 467" style="enable-background:new 0 0 406 467;" xml:space="preserve">

                      <path class="st0" d="M15.6,247.8c-3.1,0-5.6,2.5-5.6,5.6v157c0,3.1,2.5,5.6,5.6,5.6h28.9c6.5,23.7,28.1,41.1,53.7,41.1
	c25.6,0,47.2-17.5,53.7-41.1h104.1c6.5,23.7,28.1,41.1,53.7,41.1c25.6,0,47.2-17.5,53.7-41.1h28.9c3.1,0,5.6-2.5,5.6-5.6v-157
	c0-3.1-2.5-5.6-5.6-5.6H209v-97.4c22.7,0.7,50,5.8,61.9,24.8c1,1.6,2.8,2.6,4.7,2.6c1.9,0,3.7-1,4.7-2.6
	c14.3-22.8,49.9-36.1,86.3-29.2c1.7,0.3,3.6-0.2,4.9-1.4c1.3-1.2,1.9-3,1.7-4.8c-8-63.2-78.4-111.1-164.8-112.9V14.7
	c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6V27C111.2,29.1,41.3,77,33.5,140.1c-0.2,1.8,0.4,3.6,1.7,4.8c1.3,1.2,3.2,1.7,4.9,1.4
	c35.5-7.1,72.1,5.5,87.1,28.1c2.1,3.1,7.3,3.1,9.3,0c12.1-18.3,38.9-23.2,61.3-23.9v97.4L15.6,247.8z M361,133.8
	c-30.5-3.6-59.7,5.4-78.2,21.8c-0.6-25.5-7.5-83-55.7-116.3C294.8,46.7,350.1,85.1,361,133.8L361,133.8z M60.4,133
	c-4.8,0-9.6,0.3-14.5,0.9c10.7-48.7,65.7-87.1,133.4-94.6c-47.2,32.7-54.7,88.5-55.6,114.7C107.9,140.9,85.2,133,60.4,133L60.4,133z
	 M134.8,159.5c-0.1-9.4,0.7-26.2,5.8-44.8c10-36.1,31.1-61.6,62.6-75.9c31.5,14.3,52.6,39.8,62.6,75.9c5,18.2,5.9,34.8,5.8,44.3
	c-14.3-13-37.5-19.9-68.1-19.9C172.4,139.1,149,146.2,134.8,159.5L134.8,159.5z M98.2,445.9c-24.6,0-44.6-20.1-44.6-44.7
	c0-24.7,20-44.7,44.6-44.7s44.6,20.1,44.6,44.7C142.8,425.9,122.8,445.9,98.2,445.9z M309.8,445.9c-24.6,0-44.6-20.1-44.6-44.7
	c0-24.7,20-44.7,44.6-44.7s44.6,20.1,44.6,44.7S334.3,445.9,309.8,445.9z M386.7,404.8h-21.4c0.1-1.2,0.2-2.4,0.2-3.6
	c0-30.8-25-55.9-55.8-55.9S254,370.4,254,401.2c0,1.2,0.1,2.4,0.2,3.6H153.8c0.1-1.2,0.2-2.4,0.2-3.6c0-30.8-25-55.9-55.8-55.9
	s-55.8,25.1-55.8,55.9c0,1.2,0.1,2.4,0.2,3.6H21.2l0-145.8h365.5L386.7,404.8L386.7,404.8z" />
                      <path class="st1" d="M309.8,377.2c-13.2,0-24,10.8-24,24c0,13.2,10.7,24,24,24s24-10.8,24-24S323,377.2,309.8,377.2z M309.8,414
	c-7,0-12.8-5.8-12.8-12.8c0-7.1,5.7-12.8,12.8-12.8s12.8,5.8,12.8,12.8C322.5,408.3,316.8,414,309.8,414z" />
                      <path class="st1" d="M98.2,377.2c-13.2,0-24,10.8-24,24c0,13.2,10.7,24,24,24s24-10.8,24-24S111.4,377.2,98.2,377.2z M98.2,414
	c-7,0-12.8-5.8-12.8-12.8c0-7.1,5.7-12.8,12.8-12.8s12.8,5.8,12.8,12.8C111,408.3,105.3,414,98.2,414z" />
                    </svg>
                    Prime or Tier 1 Vendor
                  </label>
                </p>

                <p class="radioOption-Item">
                  <input type="radio" name="clientType" formControlName="clientType" id="staffAgency"
                    value="Staffing Agency" class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="staffAgency">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 700 700" style="enable-background:new 0 0 700 700;" xml:space="preserve">

                      <path class="st0"
                        d="M403.8,269.1c1-3-0.5-6.2-3.4-7.3c-2.9-1.1-6.2,0.3-7.4,3.2c-0.4,0.9-9.4,23.1-43,23.1S307.3,266,307,265
	c-1.2-2.9-4.5-4.3-7.4-3.2c-2.9,1.1-4.4,4.3-3.4,7.3c0.5,1.2,12,30.6,53.8,30.6C391.9,299.6,403.4,270.3,403.8,269.1L403.8,269.1z" />
                      <path class="st1"
                        d="M558,536.6l-3.8-65.5v0c-1-13.3-5.9-26-14-36.6c-8.1-10.6-19.1-18.5-31.7-23l-80.3-28.2l-27.9-17.8l-6.8-9.6h0
	c-1.8-2.5-2.9-5.5-3.1-8.5c0-0.1,0-0.1,0-0.2c24.3-8.2,45.5-23.8,60.4-44.7c15-20.8,23.1-45.9,23.1-71.5v-12.7
	c10.5-1.3,20.2-6.3,27.2-14.2c7-7.9,10.9-18.1,10.9-28.7v-0.8c0-10.6-3.9-20.8-10.9-28.7c-7-7.9-16.7-13-27.2-14.2V68.3
	c0-15.4-6.1-30.1-17-41c-10.9-10.9-25.6-17-41-17H284.4c-15.4,0-30.2,6.1-41,17c-10.9,10.9-17,25.6-17,41v63.6
	c-10.5,1.2-20.2,6.3-27.2,14.2c-7,7.9-10.9,18.1-10.9,28.7v0.8c0,10.6,3.9,20.8,10.9,28.7c7,7.9,16.7,13,27.2,14.2v12.7
	c0,25.7,8.1,50.7,23.1,71.5c15,20.8,36.1,36.5,60.4,44.7c0,0.1,0,0.1,0,0.2c-0.3,3.1-1.3,6-3.1,8.6l-6.8,9.6L272,383.4l-80.3,28.2
	c-12.6,4.4-23.6,12.4-31.8,23c-8.1,10.6-13,23.3-14,36.6l-3.8,65.4l0,0c-0.2,3.2,2.3,5.9,5.5,6.1h0.3c3.1,0,5.6-2.4,5.8-5.5
	l3.8-65.3c0.9-11.1,4.9-21.6,11.7-30.4c6.8-8.8,15.9-15.4,26.4-19.1l76.7-26.9l33.4,51.4c1,1.5,2.6,2.5,4.4,2.6h0.5
	c1.6,0,3.1-0.7,4.2-1.8l5-5.3l11,9.4c0.5,0.5,1,0.9,1.6,1.4l-13.4,71.2v0c-0.4,2.2,0.5,4.5,2.3,5.8l25.6,18.4c2,1.4,4.7,1.4,6.7,0
	l25.6-18.4c1.8-1.3,2.7-3.6,2.3-5.8L368,453.3c0.4-0.3,0.9-0.7,1.3-1.1l11.7-9.3l4.6,4.9l0,0c1.1,1.2,2.6,1.8,4.2,1.8h0.5
	c1.8-0.1,3.4-1.1,4.4-2.6l33.4-51.4l76.7,26.9c10.4,3.7,19.6,10.3,26.4,19c6.8,8.8,10.8,19.3,11.7,30.3l3.8,65.4
	c0.2,3.1,2.7,5.5,5.8,5.5h0.3C555.8,542.4,558.1,539.7,558,536.6L558,536.6z M284.4,21.8h131.4c12.3,0,24.1,4.9,32.9,13.6
	c8.7,8.7,13.6,20.5,13.6,32.9v63.1c-9.5-1.1-30.4-6.8-52.9-33.8v0c-2.5-3.1-6.3-4.9-10.3-5c-4-0.1-7.8,1.7-10.5,4.7
	c-6.8,7.9-20.8,21.1-38.5,21.1s-31.8-13.2-38.6-21.1c-2.6-3-6.4-4.7-10.4-4.7c-4,0-7.8,1.9-10.4,5c-22.5,27-43.4,32.7-52.9,33.8
	V68.3c0-12.3,4.9-24.2,13.7-32.9C260.2,26.7,272,21.8,284.4,21.8L284.4,21.8z M237.8,231.1v-18.2c0-3.2-2.6-5.8-5.8-5.8h-0.8
	c-8.4,0-16.4-3.3-22.4-9.3c-5.9-5.9-9.3-14-9.3-22.3v-0.8c0-8.4,3.3-16.4,9.3-22.3c5.9-5.9,14-9.3,22.3-9.3h0.5h1.8
	c8,0,36.5-2.7,66-38.2h0c0.4-0.5,1-0.8,1.6-0.8c0.6,0,1.1,0.3,1.5,0.7c8.1,9.4,25,25.1,47.2,25.1s39.2-15.7,47.2-25.1
	c0.4-0.4,0.9-0.7,1.5-0.7c0.6,0,1.2,0.3,1.6,0.8c29.5,35.5,58,38.2,66,38.2h1.8h0.5h0c8.4,0,16.4,3.3,22.3,9.3
	c5.9,5.9,9.3,14,9.3,22.3v0.8c0,8.4-3.3,16.4-9.3,22.3c-5.9,5.9-14,9.3-22.4,9.3H468c-3.2,0-5.8,2.6-5.8,5.8v18.2
	c0,29.4-11.7,57.6-32.5,78.5c-20.8,20.8-49,32.5-78.5,32.6h-2.4h0c-29.4,0-57.6-11.7-78.5-32.6C249.6,288.8,237.9,260.6,237.8,231.1
	L237.8,231.1z M348.8,353.7h2.4h0c9.4,0,18.7-1.1,27.8-3.2c0.7,4.4,2.4,8.6,4.9,12.2l4.3,6L350,398.3l-38.2-29.5l4.2-6h0
	c2.6-3.6,4.3-7.8,5-12.2C330.1,352.6,339.5,353.7,348.8,353.7L348.8,353.7z M282.5,390.4l21-13.5l35.9,27.7l-28.2,29.9L282.5,390.4z
	 M350,537l-19.2-13.8l12.5-66.4h13.5l12.5,66.4L350,537z M361.7,443.5L361.7,443.5c-0.2,0.1-0.4,0.3-0.5,0.5
	c-0.4,0.4-0.8,0.7-1.3,0.9c-0.2,0.1-0.4,0.1-0.7,0.2c-0.4,0.1-0.7,0.2-1.1,0.2h-16.3c-0.3,0-0.7,0-1-0.1c-0.2-0.1-0.4-0.2-0.7-0.2
	c-0.6-0.3-1.2-0.7-1.7-1.2l-10.9-9.3l22.5-23.5l22.8,23.8L361.7,443.5z M388.8,434.7l-28.2-30l35.9-27.7l21,13.5L388.8,434.7z" />
                      <path class="st0" d="M477.3,494.8h-40.8c-3.1,0.1-5.5,2.7-5.5,5.8c0,3.1,2.4,5.6,5.5,5.8h40.8h0c3.1-0.1,5.5-2.7,5.5-5.8
	C482.8,497.5,480.4,495,477.3,494.8L477.3,494.8z" />
                      <path class="st0" d="M301.7,222.6c1.5,0,3-0.6,4.1-1.7c1.1-1.1,1.7-2.6,1.7-4.1v-18.6c-0.1-3.1-2.7-5.5-5.8-5.5s-5.6,2.4-5.8,5.5
	v18.6c0,1.5,0.6,3,1.7,4.1C298.7,222,300.1,222.6,301.7,222.6L301.7,222.6z" />
                      <path class="st0" d="M398.5,222.6c1.5,0,3-0.6,4.1-1.7c1.1-1.1,1.7-2.6,1.7-4.1v-18.6c-0.1-3.1-2.7-5.5-5.8-5.5
	c-3.1,0-5.6,2.4-5.8,5.5v18.6c0,1.5,0.6,3,1.7,4.1C395.5,222,397,222.6,398.5,222.6L398.5,222.6z" />
                    </svg>
                    Staffing Agency
                  </label>
                </p>

              </div>
              <div class="radio-with-Icon">

                <!-- <p class="radioOption-Item">
                  <input type="radio" name="clientType" formControlName="clientType" id="Vendor" value="Vendor"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="Vendor">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 551.5 567.6" style="enable-background:new 0 0 551.5 567.6;" xml:space="preserve">

                      <path class="st0"
                        d="M220,556.5l-47.2-81.7c-1.3-2.2-1.2-4.8,0.1-6.9l47.2-81.7c1.3-2.2,3.6-3.4,6-3.4h94.3c2.5,0,4.8,1.4,5.9,3.5
	l47.2,81.7c1.3,2.2,1.2,4.8-0.1,6.9l-47.2,81.7c-1.3,2.2-3.6,3.4-6,3.4h-94.3C223.3,560,221.1,558.6,220,556.5L220,556.5z
	 M229.8,546.5l-43.3-75.1l43.3-75.1h86.7l43.3,75.1l-43.3,75.1H229.8z M326.2,3.5l47.2,81.7c1.3,2.2,1.2,4.8-0.1,6.9l-47.2,81.7
	c-1.3,2.2-3.6,3.4-6,3.4h-94.3c-2.5,0-4.8-1.4-5.9-3.5l-47.2-81.7c-1.3-2.2-1.2-4.8,0.1-6.9L220,3.4c1.3-2.2,3.6-3.4,6-3.4h94.3
	C322.9,0,325.1,1.4,326.2,3.5L326.2,3.5z M316.4,13.5h-86.7l-43.3,75.1l43.3,75.1h86.7l43.3-75.1L316.4,13.5z M539.1,187.8
	L492,269.5c-1.3,2.2-3.6,3.4-6,3.4h-94.3c-2.5,0-4.8-1.4-5.9-3.5l-47.2-81.7c-1.3-2.2-1.2-4.8,0.1-6.9l47.2-81.7
	c1.3-2.2,3.6-3.4,6-3.4h94.3c2.5,0,4.8,1.4,5.9,3.5l47.2,81.7C540.5,183.1,540.3,185.7,539.1,187.8L539.1,187.8z M525.5,184.3
	l-43.3-75.1h-86.7l-43.3,75.1l43.3,75.1h86.7L525.5,184.3z M7,372.2l47.2-81.7c1.3-2.2,3.6-3.4,6-3.4h94.3c2.5,0,4.8,1.4,5.9,3.5
	l47.2,81.7c1.3,2.2,1.2,4.8-0.1,6.9l-47.2,81.7c-1.3,2.2-3.6,3.4-6,3.4H60.1c-2.5,0-4.8-1.4-5.9-3.5L7,379.1
	C5.7,376.9,5.8,374.3,7,372.2L7,372.2z M20.6,375.7L64,450.8h86.7l43.3-75.1l-43.3-75.1H64L20.6,375.7z M60.2,95.7h94.3
	c2.5,0,4.8,1.4,5.9,3.5l47.2,81.7c1.3,2.2,1.2,4.8-0.1,6.9l-47.2,81.7c-1.3,2.2-3.6,3.4-6,3.4H60.1c-2.5,0-4.8-1.4-5.9-3.5L7,187.6
	c-1.3-2.2-1.2-4.8,0.1-6.9l47.2-81.7C55.5,96.9,57.8,95.7,60.2,95.7L60.2,95.7z M64,109.2l-43.3,75.1L64,259.3h86.7l43.3-75.1
	l-43.3-75.1H64z M486,464.3h-94.3c-2.5,0-4.8-1.4-5.9-3.5l-47.2-81.7c-1.3-2.2-1.2-4.8,0.1-6.9l47.2-81.7c1.3-2.2,3.6-3.4,6-3.4
	h94.3c2.5,0,4.8,1.4,5.9,3.5l47.2,81.7c1.3,2.2,1.2,4.8-0.1,6.9L492,460.9C490.7,463.1,488.4,464.3,486,464.3L486,464.3z
	 M482.2,450.8l43.3-75.1l-43.3-75.1h-86.7l-43.3,75.1l43.3,75.1H482.2z M219.9,365.9l-47.2-81.7c-1.3-2.2-1.2-4.8,0.1-6.9l47.2-81.7
	c1.3-2.2,3.6-3.4,6-3.4h94.3c2.5,0,4.8,1.4,5.9,3.5l47.2,81.7c1.3,2.2,1.2,4.8-0.1,6.9L326.2,366c-1.3,2.2-3.6,3.4-6,3.4h-94.3
	C223.3,369.4,221.1,368,219.9,365.9L219.9,365.9z M229.7,355.9h86.7l43.3-75.1l-43.3-75.1h-86.7l-43.3,75.1L229.7,355.9z M240.2,230
	c1.2-2.1,3.4-3.5,5.9-3.5h53.8c2.4,0,4.7,1.2,6,3.4l27,46.7c1.3,2.2,1.2,4.8-0.1,6.9l-26.9,46.6c-1.3,2.2-3.6,3.4-6,3.4h-53.8
	c-2.5,0-4.8-1.4-5.9-3.5l-26.9-46.6c-1.3-2.2-1.2-4.8,0.1-6.9L240.2,230z M250,240l-23.1,40l23.1,40h46.2l23.1-40l-23.1-40H250z" />
                      <polygon class="st1"
                        points="297.1,238.5 249.1,238.5 225.2,280 249.1,321.5 297.1,321.5 321,280 " />
                    </svg>

                    Vendor
                  </label>
                </p> -->


                <!-- <p class="radioOption-Item"
                  *ngIf="userClassificationForm.value.userType=='BENCH_RECRUITER' || userClassificationForm.value.userType=='MANAGEMENT_TALENT_ACQUISITION'">
                  <input type="radio" id="Supplier" value="Supplier" name="clientType" formControlName="clientType"
                    class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false">
                  <label for="Supplier">
                    <svg version="1.1" id="Layer_1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 503 525" style="enable-background:new 0 0 503 525;" xml:space="preserve">

                      <path class="st0" d="M261,13c-57.2,0-103.7,46.5-103.7,103.7c0,57.2,46.5,103.7,103.7,103.7c56.7,0,102.7-45.7,103.5-102.2v0
	c0.1-0.5,0.1-1,0.1-1.5c0-0.5-0.1-1-0.1-1.5C363.7,58.7,317.7,13,261,13L261,13z M261,28.2c49,0,88.5,39.5,88.5,88.5
	c0,49-39.5,88.5-88.5,88.5s-88.5-39.5-88.5-88.5S212,28.2,261,28.2z M375.3,133.6c-2.3,0-4.4,1-5.9,2.7c-1.3,1.5-1.9,3.5-1.8,5.5
	c0.2,2,1.1,3.9,2.7,5.2c23,19.5,49.5,34.8,78,45c6.6,2.3,13.2,4.4,20,6.2l-13.8,8.1l0,0c-3.6,2.1-4.8,6.8-2.7,10.4
	c1.3,2.3,3.8,3.7,6.4,3.8v0h0.3c1.3,0,2.6-0.4,3.7-1l30.4-17.8v0c0.6-0.3,1.1-0.7,1.5-1.2c0.2-0.2,0.4-0.4,0.6-0.6
	c0.4-0.4,0.7-0.9,0.9-1.5c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0,0,0c0.2-0.3,0.3-0.7,0.4-1.1c0-0.1,0-0.2,0.1-0.3v0c0-0.2,0.1-0.3,0.1-0.5
	c0-0.2,0.1-0.3,0.1-0.5v-0.1v-0.1c0-0.1,0-0.2,0-0.3V195v-0.1v-0.2v0c0-0.1,0-0.2,0-0.2v0c0-0.1,0-0.2,0-0.2v0c0-0.1,0-0.2,0-0.3
	c-0.1-0.5-0.2-0.9-0.3-1.4c-0.2-0.5-0.4-1.1-0.8-1.6l-17.7-30.1v0c-2.1-3.6-6.8-4.8-10.4-2.7c-3.6,2.1-4.8,6.8-2.7,10.4l9,15.4
	c-6.7-1.8-13.4-3.8-19.9-6.1c-26.7-9.5-51.6-23.9-73.3-42.3h0C378.8,134.2,377.1,133.6,375.3,133.6L375.3,133.6z M111.5,161.3
	C54.3,161.3,7.8,207.8,7.8,265s46.5,103.7,103.7,103.7c56.7,0,102.7-45.7,103.5-102.2h0c0.1-0.5,0.1-1,0.1-1.5c0-0.5-0.1-1-0.2-1.5
	C214.2,207,168.1,161.3,111.5,161.3L111.5,161.3z M111.5,176.5c49,0,88.5,39.5,88.5,88.5s-39.5,88.5-88.5,88.5S22.9,314,22.9,265
	S62.5,176.5,111.5,176.5z M460.6,239.3L460.6,239.3C460.5,239.3,460.5,239.3,460.6,239.3c-2.1,0.1-3.9,0.9-5.3,2.3
	c-1.4,1.4-2.2,3.4-2.2,5.4s0.8,3.9,2.3,5.3l11.9,11.8H234.2c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6h233l-11.9,11.8h0
	c-3,2.9-3,7.7-0.1,10.7c2.9,3,7.7,3,10.7,0.1l24.9-24.6v0c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
	c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
	c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0s0,0,0,0
	c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1
	c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.2
	c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0v0c0,0,0-0.1,0-0.1
	c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1
	c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3v0v0
	c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2v0v0v0c0-0.1,0-0.1,0-0.1v0v0v0c0-0.1,0-0.2,0-0.2v0c0-0.1,0-0.2,0-0.2v0
	c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2v0v0c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1v0c0,0,0-0.1,0-0.1l0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1
	c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.2
	c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0,0v0c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1
	c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1
	c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1
	c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1
	c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1l-0.1-0.1l-25-24.6h0C464.5,240.1,462.6,239.3,460.6,239.3L460.6,239.3z M458.1,309.6
	L458.1,309.6c-2.6,0.1-5.1,1.5-6.4,3.8c-2.1,3.6-0.9,8.3,2.7,10.4l13.8,8.1c-6.7,1.8-13.4,3.9-20,6.2c-28.4,10.2-54.9,25.5-78,45h0
	c-1.5,1.3-2.5,3.2-2.7,5.2c-0.2,2,0.5,4,1.8,5.5s3.2,2.5,5.2,2.7c2,0.2,4-0.5,5.5-1.8c21.6-18.3,46.6-32.7,73.3-42.3
	c6.5-2.3,13.2-4.4,19.9-6.1l-9,15.3h0c-2.1,3.6-0.9,8.3,2.7,10.4c3.6,2.1,8.3,0.9,10.4-2.7l17.7-30.1v0c0.3-0.5,0.6-1,0.8-1.6
	c0.2-0.4,0.3-0.9,0.3-1.4c0-0.1,0-0.2,0-0.3v0c0-0.1,0-0.2,0-0.2v0c0-0.1,0-0.2,0-0.2v0v-0.2V335v-0.2c0-0.1,0-0.2,0-0.3v-0.1v-0.1
	c0-0.2,0-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5v0c0-0.1,0-0.2-0.1-0.3c-0.1-0.4-0.2-0.7-0.4-1.1c0,0,0,0,0,0c0-0.1-0.1-0.2-0.1-0.2
	c-0.2-0.5-0.6-1-0.9-1.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5-0.5-1-0.9-1.5-1.2l-30.4-17.8c-1.1-0.7-2.4-1-3.7-1
	C458.3,309.6,458.2,309.6,458.1,309.6L458.1,309.6z M261,309.6c-57.2,0-103.7,46.5-103.7,103.7c0,57.2,46.5,103.7,103.7,103.7
	c56.7,0,102.7-45.7,103.5-102.2h0c0.1-0.5,0.1-1,0.1-1.5c0-0.5-0.1-1-0.1-1.5C363.7,355.3,317.7,309.6,261,309.6L261,309.6z
	 M261,324.8c49,0,88.5,39.5,88.5,88.5S310,501.8,261,501.8s-88.5-39.5-88.5-88.5S212,324.8,261,324.8L261,324.8z" />
                      <circle class="st1" cx="111.5" cy="264.5" r="77" />
                      <circle class="st1" cx="261" cy="116.7" r="77" />
                      <circle class="st1" cx="261" cy="413.3" r="77" />
                    </svg>
                    Supplier
                  </label>
                </p> -->


                <!-- <p class="radioOption-Item">
                <input type="radio" name="BannerTypes" id="Others" value="false"
                  class="ng-valid ng-dirty ng-touched ng-empty" aria-invalid="false" style="">
                <label for="Others">
                  <svg version="1.1" id="Layer_1"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 461 366"
                    style="enable-background:new 0 0 461 366;" xml:space="preserve">

                    <path class="st0" d="M276.7,53.8c-12.4,12.4-29.9,14.9-39.2,5.7c-9.3-9.3-6.7-26.8,5.7-39.2c12.4-12.4,29.9-14.9,39.2-5.7
	C291.7,23.9,289.1,41.4,276.7,53.8" />
                    <path class="st1" d="M125.2,176.5c-8.9-3.9-17.9-7.3-27.1-9.7c-9.7-2.3-20-3.6-31.1-3.9h-59v28h61.7c24.6,0,49.1,12.8,75.1,26.4
	c15.3,8,30.9,16.1,47.1,21.8C176,214.1,154.4,190.6,125.2,176.5L125.2,176.5z" />
                    <path class="st1" d="M397.7,163c-16,0.3-30.5,2.9-43.7,7.4c-0.9,0.3-1.8,0.7-2.7,1c-35.5,13-61,39.3-79,67.7
	c16-5.7,31.5-13.8,46.8-21.7c25.9-13.6,50.5-26.4,75.1-26.4H456v-28L397.7,163z" />
                    <path class="st0" d="M276.8,166.2c-12.4,12.4-29.9,14.9-39.2,5.7c-9.3-9.2-6.7-26.8,5.7-39.2c12.4-12.4,29.9-14.9,39.2-5.7
	C291.7,136.3,289.2,153.8,276.8,166.2" />
                    <path class="st0" d="M220.9,75.4c12.4,12.4,14.9,29.9,5.7,39.2c-9.3,9.3-26.8,6.7-39.2-5.7C175,96.5,172.5,79,181.7,69.7
	S208.5,63,220.9,75.4" />
                    <path class="st1" d="M232,359c-30.8,0-60.8-14.8-89.8-29.2c-27.5-13.6-53.5-26.5-78.2-26.5H7.9v-28H64c31.3,0,61.4,14.9,90.6,29.4
	c27.3,13.5,53.1,26.3,77.4,26.3c24.1,0,49.6-12.7,76.6-26.1c29.2-14.5,59.4-29.6,91.1-29.6h0.3h56v28h-56h-0.2
	c-25.2,0-51.2,12.9-78.7,26.6C292.4,344.2,262.7,359,232,359L232,359z" />
                    <path class="st1" d="M232,303.3c-30.8,0-60.8-14.8-89.8-29.2c-27.5-13.6-53.5-26.5-78.2-26.5H7.9v-28H64c31.3,0,61.4,14.9,90.6,29.4
	c27.3,13.5,53.1,26.3,77.4,26.3c24.1,0,49.6-12.7,76.6-26.1c29.2-14.5,59.4-29.6,91.1-29.6h0.3h56v28l-56,0h-0.2
	c-25.2,0-51.2,12.9-78.7,26.6C292.4,288.6,262.7,303.3,232,303.3L232,303.3z" />
                  </svg>
                  Others
                </label>
              </p> -->
              </div>
            </div>

          </form>
        </ng-template>

      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2 stepUIContent"></div>
  </div>
</section>
